import React, { useState, useMemo, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  useTheme,
  Tab,
  Tabs,
  TextField,
  Button,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Divider,
  InputAdornment,
  Alert,
  Snackbar,
  Grid,
  IconButton,
  Badge,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
} from "@mui/material";
import Header from "components/Header";
import {
  AccountBalanceWalletOutlined,
  AccountBalanceOutlined,
  TrendingUpOutlined,
  TrendingDownOutlined,
  ReceiptLongOutlined,
  AddCircleOutline,
  PaymentOutlined,
  CategoryOutlined,
  ChecklistOutlined,
  DeleteOutline,
  AddShoppingCartOutlined,
  SendOutlined,
  KeyboardArrowDown,
  EditOutlined,
  CheckBoxOutlined,
  CalendarMonthOutlined,
  Close as CloseIcon,
  PrintOutlined,
  VisibilityOutlined,
  Search,
  AccessTimeOutlined,
} from "@mui/icons-material";
import formatRupiah from "utils/formatRupiah";
import moment from "moment";
import "moment/locale/id";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteListTransaksiWarkat,
  realisasiListTransaksiWarkat,
  fetchListPerkiraan,
  fetchListTransaksi,
  fetchListTransaksiWarkat,
  postListTransaksiWarkat,
  editTanggalListTransaksiWarkat,
} from "state/alokasiAction";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import KonfirmasiModal from "components/Modals/KonfirmasiModal";
import UbahTanggalModal from "components/Modals/UbahTanggalModal";
import DetailSetoranCabangModal from "components/Modals/DetailSetoranCabangModal";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { fetchListSetoranPerCabang } from "state/setoranAction";
moment.locale("id");

const AlokasiDC = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [tabValue, setTabValue] = useState(0);

  const [alokasi, setAlokasi] = useState([]);
  const [tanggalAlokasi, setTanggalAlokasi] = useState(moment());

  const [selectedTransaksi, setSelectedTransaksi] = useState(null);
  const [selectedTransaksis, setSelectedTransaksis] = useState([]);
  const [nominalBayar, setNominalBayar] = useState("");
  const [nominalBayarMulti, setNominalBayarMulti] = useState({});

  useEffect(() => {
    if (selectedTransaksis.length > 0) {
      const total = selectedTransaksis.reduce((sum, item) => {
        const nominal = nominalBayarMulti[item.no_bukti_penerimaan] || 0;
        return sum + nominal;
      }, 0);
      setNominalBayar(total > 0 ? total.toLocaleString("id-ID") : "");
    }
  }, [nominalBayarMulti, selectedTransaksis]);

  const [selectedTipe, setSelectedTipe] = useState(null);
  const [namaTransaksi, setNamaTransaksi] = useState("");
  const [nominalLainnya, setNominalLainnya] = useState("");

  // State khusus tab Pendapatan Lainnya
  const [selectedTipePendapatan, setSelectedTipePendapatan] = useState(null);
  const [namaPendapatan, setNamaPendapatan] = useState("");
  const [nominalPendapatan, setNominalPendapatan] = useState("");

  const [openKonfirmasi, setOpenKonfirmasi] = useState(false);
  const [tanggalPengganti, setTanggalPengganti] = useState(null);
  const [openUbahTanggal, setOpenUbahTanggal] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [expandedRows, setExpandedRows] = useState({});
  const [searchSubItemText, setSearchSubItemText] = useState("");

  // States for Detail Setoran Cabang Modal
  const [openDetailSetoranCabang, setOpenDetailSetoranCabang] = useState(false);

  const handleOpenDetailSetoranCabang = async (subItem) => {
    dispatch(
      fetchListSetoranPerCabang(subItem.tanggal_kas, subItem.tanggal_setoran),
    );
    setOpenDetailSetoranCabang(true);
  };
  const {
    list_transaksi_warkat,
    list_transaksi,
    list_perkiraan,
    list_setoran_percabang,
  } = useSelector((state) => state.alokasi);
  const { status, message, isLoading } = useSelector((state) => state.global);

  const getInit = () => {
    dispatch(fetchListTransaksiWarkat());
    dispatch(fetchListTransaksi());
    dispatch(fetchListPerkiraan());
  };

  useEffect(() => {
    getInit();
  }, []);

  const [openPilihTransaksi, setOpenPilihTransaksi] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState(moment().startOf("month"));
  const [endDate, setEndDate] = useState(moment().endOf("month"));
  const [startJatuhTempo, setStartJatuhTempo] = useState(null);
  const [endJatuhTempo, setEndJatuhTempo] = useState(null);

  const filteredListTransaksi = useMemo(() => {
    if (!list_transaksi || !Array.isArray(list_transaksi)) return [];

    let result = [...list_transaksi];

    if (startJatuhTempo && endJatuhTempo) {
      result = result.filter((item) => {
        const tglTransaksi = moment(item.tanggal_transaksi);
        const top = parseInt(item.top) || 0;
        const tglJatuhTempo = tglTransaksi.add(top, "days");
        return (
          tglJatuhTempo.isSameOrAfter(startJatuhTempo, "day") &&
          tglJatuhTempo.isSameOrBefore(endJatuhTempo, "day")
        );
      });
    }

    if (searchText) {
      const lower = searchText.toLowerCase();
      result = result.filter(
        (item) =>
          (item.nama_supplier || "").toLowerCase().includes(lower) ||
          (item.no_bukti_penerimaan || "").toLowerCase().includes(lower),
      );
    }

    result.sort((a, b) => {
      const aTop = parseInt(a.top) || 0;
      const bTop = parseInt(b.top) || 0;
      const aJatuhTempo = moment(a.tanggal_transaksi).add(aTop, "days");
      const bJatuhTempo = moment(b.tanggal_transaksi).add(bTop, "days");
      return aJatuhTempo.valueOf() - bJatuhTempo.valueOf();
    });

    return result;
  }, [list_transaksi, searchText, startJatuhTempo, endJatuhTempo]);

  const handleToggleTransaksi = (item) => {
    setSelectedTransaksis((prev) => {
      const exists = prev.find(
        (t) => t.no_bukti_penerimaan === item.no_bukti_penerimaan,
      );
      if (exists) {
        return prev.filter(
          (t) => t.no_bukti_penerimaan !== item.no_bukti_penerimaan,
        );
      }
      return [...prev, item];
    });
  };

  const handlePilihMultiple = () => {
    if (selectedTransaksis.length === 0) return;
    const initialNominals = {};
    selectedTransaksis.forEach((item) => {
      initialNominals[item.no_bukti_penerimaan] =
        parseInt(item.sisa_hutang) || 0;
    });
    setNominalBayarMulti(initialNominals);
    const totalSisa = selectedTransaksis.reduce(
      (sum, item) => sum + (parseInt(item.sisa_hutang) || 0),
      0,
    );
    setNominalBayar(totalSisa.toLocaleString("id-ID"));
    setSearchText("");
    setStartJatuhTempo(null);
    setEndJatuhTempo(null);
    setOpenPilihTransaksi(false);
  };

  const handleResetFilterTransaksi = () => {
    setSearchText("");
    setStartJatuhTempo(null);
    setEndJatuhTempo(null);
  };

  const handleCloseSnackbar = () => {
    setSelectedTransaksi(null);
    setTanggalPengganti(null);
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListTransaksiWarkat());
    setAlokasi([]);
  };

  const handleDelete = () => {
    dispatch(deleteListTransaksiWarkat(selectedTransaksi.id));
    setOpenKonfirmasi(false);
    setSelectedTransaksi(null);
    setTanggalPengganti(null);
  };

  const handleUbahTanggal = (tanggalBaru) => {
    dispatch(
      editTanggalListTransaksiWarkat({
        id: selectedTransaksi.id,
        tanggalnew: tanggalBaru,
      }),
    );
    setOpenUbahTanggal(false);
    setTanggalPengganti(null);
  };

  const handlePrintAlokasi = (row) => {
    const dataToPrint = row.items || [row.singleItem];
    const tanggalSetoran = row.tanggal_setoran;
    const tanggalKasOmzet = row.list_pencapaian.tgl_kas;
    const total_pemasukan = list_transaksi_warkat
      .filter(
        (item) =>
          item.tanggal_kas === tanggalKasOmzet &&
          item.tanggal_setoran === tanggalSetoran &&
          item.tipe === "pemasukan",
      )
      .reduce((sum, item) => sum + (Number(item.nominal) || 0), 0);

    const tipe = row.tipe;
    const cetakDate = moment().format("DD MMMM YYYY, HH:mm");
    const tanggalFormatted = moment(tanggalSetoran).format("DD MMMM YYYY");
    const tanggalKasFormatted = moment(tanggalKasOmzet).format("DD MMMM YYYY");
    const tipeLabel = tipe === "pemasukan" ? "PEMASUKAN" : "PENGELUARAN";
    const tipeColor = tipe === "pemasukan" ? "#2e7d32" : "#c62828";
    const tipeBg = tipe === "pemasukan" ? "#e8f5e9" : "#ffebee";
    const omzetAkhir =
      (row.list_pencapaian?.total_omzet_data || 0) -
      (row.list_pencapaian?.total_pengeluaran || 0);

    const fmtRp = (val) => {
      if (!val || val === "0" || val === "0.00") return "-";
      const num = parseFloat(val);
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(num);
    };

    const totalNominal = dataToPrint.reduce(
      (sum, item) => sum + (Number(item.nominal) || 0),
      0,
    );

    const tableRows = dataToPrint
      .map(
        (item, i) => `
            <tr class="${i % 2 === 0 ? "even" : "odd"}">
              <td class="center">${i + 1}</td>
              <td>${item.nama || "-"}</td>
              <td>${item.kode_perkiraan ? '<span class="badge badge-blue">' + item.kode_perkiraan + "</span> " + (item.nama_perkiraan || "") : "-"}</td>
              <td>${item.nama_supplier || "-"}</td>
              <td class="right bold" style="color:${tipeColor}">${fmtRp(item.nominal)}</td>
              <td class="center checkbox-cell">☐</td>
              <td class="center"></td>
            </tr>`,
      )
      .join("");

    const htmlContent = `<!DOCTYPE html>
    <html lang="id">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Lembar Persetujuan Alokasi - ${tanggalFormatted}</title>
      <style>
        @page { size: A4 portrait; margin: 12mm 10mm; }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        html { width: 210mm; }
        body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; color: #1a1a2e; background: #fff; line-height: 1.4; width: 190mm; max-width: 190mm; margin: 0 auto; overflow-x: hidden; }

        /* HEADER */
        .header { display: flex; justify-content: space-between; align-items: flex-start; padding: 14px 0 12px; border-bottom: 3px solid #16213e; margin-bottom: 14px; }
        .header-left h1 { font-size: 16px; color: #16213e; letter-spacing: 1.5px; margin-bottom: 2px; }
        .header-left .company { font-size: 11px; color: #0f3460; font-weight: 600; }
        .header-right { text-align: right; }
        .header-right .doc-type { font-size: 9px; color: #666; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 3px; }
        .header-right .doc-date { font-size: 12px; font-weight: 700; color: #16213e; }
        .header-right .doc-tipe { display: inline-block; margin-top: 4px; padding: 3px 12px; border-radius: 12px; font-size: 10px; font-weight: 700; letter-spacing: 0.5px; background: ${tipeBg}; color: ${tipeColor}; }

        /* SUMMARY CARD */
        .summary-bar { display: flex; gap: 8px; margin-bottom: 14px; }
        .summary-card { flex: 1; border-radius: 6px; padding: 10px 14px; }
        .summary-card .label { font-size: 9px; text-transform: uppercase; letter-spacing: 0.8px; opacity: 0.8; margin-bottom: 3px; }
        .summary-card .value { font-size: 16px; font-weight: 800; }
        .card-total { background: linear-gradient(135deg, ${tipeBg}, ${tipe === "pemasukan" ? "#c8e6c9" : "#ffcdd2"}); color: ${tipeColor}; border-left: 4px solid ${tipeColor}; }
        .card-count { background: linear-gradient(135deg, #e3f2fd, #bbdefb); color: #0d47a1; border-left: 4px solid #1565c0; }
        .card-date { background: linear-gradient(135deg, #f3e5f5, #e1bee7); color: #4a148c; border-left: 4px solid #6a1b9a; }

        /* TABLE */
        .section-title { font-size: 11px; font-weight: 700; color: #16213e; padding: 6px 0 4px; border-bottom: 2px solid #e0e0e0; margin-bottom: 0; text-transform: uppercase; letter-spacing: 1px; }
        table { width: 100%; border-collapse: collapse; table-layout: fixed; }
        thead th { background: #16213e; color: #fff; font-size: 8.5px; text-transform: uppercase; letter-spacing: 0.4px; padding: 6px 5px; white-space: nowrap; }
        tbody td { padding: 5px 5px; border-bottom: 1px solid #eee; font-size: 9.5px; word-wrap: break-word; overflow-wrap: break-word; }
        tr.even { background: #fafafa; }
        tr.odd { background: #fff; }
        .total-row { background: #16213e; }
        .total-row td { color: #fff; font-weight: 800; font-size: 10px; padding: 8px 5px; border: none; }

        /* BADGES */
        .badge { display: inline-block; padding: 1px 6px; border-radius: 8px; font-size: 8px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.3px; white-space: nowrap; }
        .badge-green { background: #e8f5e9; color: #2e7d32; }
        .badge-red { background: #ffebee; color: #c62828; }
        .badge-blue { background: #e3f2fd; color: #1565c0; }
        .badge-orange { background: #fff3e0; color: #e65100; }

        /* CHECKBOX CELL */
        .checkbox-cell { font-size: 14px; color: #999; }

        /* UTILITIES */
        .right { text-align: right; }
        .center { text-align: center; }
        .bold { font-weight: 700; }

        /* SIGNATURE */
        .sign-section { margin-top: 30px; display: flex; justify-content: flex-end; gap: 40px; }
        .sign-box { width: 140px; text-align: center; }
        .sign-box .sign-label { font-size: 9px; color: #666; margin-bottom: 50px; }
        .sign-box .sign-line { border-bottom: 1px solid #333; margin-bottom: 4px; }
        .sign-box .sign-name { font-size: 8px; color: #999; }

        /* FOOTER */
        .footer { margin-top: 16px; padding-top: 8px; border-top: 1px solid #ccc; text-align: center; font-size: 8px; color: #999; }

        @media print {
          html, body { width: 100%; max-width: 100%; }
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="header-left">
          <h1>LEMBAR PERSETUJUAN</h1>
          <div class="company">Prima Centre DC — Sukabumi</div>
        </div>
        <div class="header-right">
          <div class="doc-type">Alokasi ${tipeLabel}</div>
          <div class="doc-date">${tanggalFormatted}</div>
          <div class="doc-tipe">${tipeLabel}</div>
        </div>
      </div>

      <div class="summary-bar">
        <div class="summary-card card-total">
          <div class="label">Total ${tipeLabel}</div>
          <div class="value">${fmtRp(totalNominal)}</div>
        </div>
        <div class="summary-card card-count">
          <div class="label">Jumlah Item</div>
          <div class="value">${dataToPrint.length}</div>
        </div>
        <div class="summary-card card-date">
          <div class="label">OMZET ${tanggalKasFormatted}</div>
          <div class="value" style="font-size:13px">${fmtRp(total_pemasukan)}</div>
        </div>
      </div>

      <p class="section-title">Detail ${tipeLabel}</p>
      <table>
        <thead>
          <tr>
            <th class="center" style="width:25px">No</th>
            <th style="width:30%">Keterangan</th>
            <th style="width:22%">Kode Transaksi</th>
            <th style="width:15%">Supplier</th>
            <th class="right" style="width:16%">Nominal</th>
            <th class="center" style="width:8%">Setujui</th>
            <th class="center" style="width:9%">Pindah Tgl</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows}
        </tbody>
        <tfoot>
          <tr class="total-row">
            <td colspan="4">TOTAL ${tipeLabel}</td>
            <td class="right">${fmtRp(totalNominal)}</td>
            <td colspan="2"></td>
          </tr>
        </tfoot>
      </table>

      <div class="sign-section">
        <div class="sign-box">
          <div class="sign-label">Disetujui oleh</div>
          <div class="sign-line"></div>
          <div class="sign-name">(_________________)</div>
        </div>
      </div>

      <div class="footer">
        Dokumen ini dicetak dari Website PRIMA Centre pada ${cetakDate}
      </div>

      <script>
        window.onload = function() { window.print(); };
      </script>
    </body>
    </html>`;

    const tab = window.open("", "_blank");
    if (tab) {
      tab.document.open();
      tab.document.write(htmlContent);
      tab.document.close();
    }
  };

  const riwayatGrouped = useMemo(() => {
    if (
      !Array.isArray(list_transaksi_warkat) ||
      list_transaksi_warkat.length === 0
    )
      return [];

    const filteredByDate = list_transaksi_warkat.filter((item) => {
      const tgl = moment(item.tanggal_setoran);
      return (
        tgl.isSameOrAfter(startDate, "day") &&
        tgl.isSameOrBefore(endDate, "day")
      );
    });

    const groups = {};
    filteredByDate.forEach((item) => {
      const key = `${item.tanggal_setoran}_${item.tipe}`;
      if (!groups[key]) {
        groups[key] = {
          tanggal_kas: item.tanggal_kas,
          tanggal_setoran: item.tanggal_setoran,
          tipe: item.tipe,
          status: item.status,
          items: [],
          totalNominal: 0,
          list_pencapaian: item.list_pencapaian || null,
        };
      } else if (item.list_pencapaian && !groups[key].list_pencapaian) {
        groups[key].list_pencapaian = item.list_pencapaian;
      }
      groups[key].items.push(item);
      groups[key].totalNominal += Number(item.nominal) || 0;
    });

    return Object.values(groups)
      .sort((a, b) => moment(b.tanggal_setoran).diff(moment(a.tanggal_setoran)))
      .map((group, idx) => ({
        id: `group_${idx}`,
        tanggal_kas: group.tanggal_kas,
        tanggal_setoran: group.tanggal_setoran,
        tipe: group.tipe,
        status: group.status,
        nominal: group.totalNominal,
        list_pencapaian: group.list_pencapaian,
        keterangan:
          group.items.length === 1
            ? group.items[0].nama
            : `${group.tipe === "pemasukan" ? "Pemasukan" : "Pengeluaran"} (${group.items.length} item)`,
        items: group.items.length > 1 ? group.items : null,
        singleItem: group.items.length === 1 ? group.items[0] : null,
      }));
  }, [list_transaksi_warkat, startDate, endDate]);

  const kasInfo = useMemo(() => {
    const data = Array.isArray(list_transaksi_warkat)
      ? list_transaksi_warkat
      : [];

    const filteredData = data.filter((r) => {
      const tgl = moment(r.tanggal_setoran);
      return (
        tgl.isSameOrAfter(startDate, "day") &&
        tgl.isSameOrBefore(endDate, "day")
      );
    });

    const pendapatan = filteredData
      .filter((r) => r.tipe === "pemasukan" && r.status === "realisasi")
      .reduce((sum, r) => sum + (Number(r.nominal) || 0), 0);

    const alokasi = filteredData
      .filter((r) => r.tipe === "pengeluaran" && r.status === "alokasi")
      .reduce((sum, r) => sum + (Number(r.nominal) || 0), 0);

    const pengeluaran = filteredData
      .filter((r) => r.tipe === "pengeluaran" && r.status === "realisasi")
      .reduce((sum, r) => sum + (Number(r.nominal) || 0), 0);

    const selisih = pendapatan - pengeluaran;

    return {
      pendapatan,
      alokasi,
      pengeluaran,
      selisih,
    };
  }, [list_transaksi_warkat, startDate, endDate]);

  const totalAlokasi = useMemo(() => {
    return alokasi.reduce((sum, item) => sum + item.nominal, 0);
  }, [alokasi]);

  const handleTambahAlokasiTerdaftar = () => {
    if (!selectedTransaksi && selectedTransaksis.length === 0) {
      setSnackbar({
        open: true,
        message: "Pilih transaksi yang akan dibayar terlebih dahulu.",
        severity: "warning",
      });
      return;
    }
    const nominal = parseInt(nominalBayar.replace(/\D/g, ""), 10);
    if (!nominal || nominal <= 0) {
      setSnackbar({
        open: true,
        message: "Masukkan nominal yang valid.",
        severity: "warning",
      });
      return;
    }

    if (selectedTransaksis.length > 0) {
      const newItems = selectedTransaksis
        .map((item) => {
          const nominalItem = nominalBayarMulti[item.no_bukti_penerimaan] || 0;
          const sisaHutang = parseInt(item.sisa_hutang) || 0;
          if (nominalItem > sisaHutang) {
            setSnackbar({
              open: true,
              message: `Nominal untuk ${item.no_bukti_penerimaan} tidak boleh melebihi sisa hutang ${formatRupiah(sisaHutang)}.`,
              severity: "error",
            });
            return null;
          }
          if (nominalItem <= 0) return null;
          return {
            id: Date.now() + Math.random(),
            keterangan: `${item.no_bukti_penerimaan} - ${item.nama_supplier}`,
            nominal: nominalItem,
            sumber: "Terdaftar",
            no_bukti: item.no_bukti_penerimaan,
            id_supplier: item.id_supplier,
            nama_supplier: item.nama_supplier,
          };
        })
        .filter(Boolean);

      if (newItems.length === 0) {
        setSnackbar({
          open: true,
          message:
            "Masukkan nominal yang valid untuk setidaknya satu transaksi.",
          severity: "warning",
        });
        return;
      }

      setAlokasi((prev) => [...prev, ...newItems]);
      setSelectedTransaksis([]);
      setNominalBayar("");
      setNominalBayarMulti({});
      setSnackbar({
        open: true,
        message: `${newItems.length} transaksi ditambahkan ke alokasi.`,
        severity: "success",
      });
      return;
    }

    if (nominal > parseInt(selectedTransaksi.sisa_hutang)) {
      setSnackbar({
        open: true,
        message: `Nominal pembayaran tidak boleh melebihi sisa hutang ${formatRupiah(parseInt(selectedTransaksi.sisa_hutang))}.`,
        severity: "error",
      });
      return;
    }

    const newItem = {
      id: Date.now(),
      keterangan: `${selectedTransaksi.no_bukti_penerimaan} - ${selectedTransaksi.nama_supplier}`,
      nominal: nominal,
      sumber: "Terdaftar",
      no_bukti: selectedTransaksi.no_bukti_penerimaan,
      id_supplier: selectedTransaksi.id_supplier,
      nama_supplier: selectedTransaksi.nama_supplier,
    };

    setAlokasi((prev) => [...prev, newItem]);
    setSelectedTransaksi(null);
    setNominalBayar("");
    setSnackbar({
      open: true,
      message: `"${newItem.keterangan}" ditambahkan ke alokasi.`,
      severity: "success",
    });
  };

  const handleTambahAlokasiLainnya = () => {
    if (!selectedTipe) {
      setSnackbar({
        open: true,
        message: "Pilih tipe pengeluaran terlebih dahulu.",
        severity: "warning",
      });
      return;
    }
    if (!namaTransaksi.trim()) {
      setSnackbar({
        open: true,
        message: "Masukkan nama transaksi.",
        severity: "warning",
      });
      return;
    }
    const nominal = parseInt(nominalLainnya.replace(/\D/g, ""), 10);
    if (!nominal || nominal <= 0) {
      setSnackbar({
        open: true,
        message: "Masukkan nominal yang valid.",
        severity: "warning",
      });
      return;
    }

    const newItem = {
      id: Date.now(),
      keterangan: `[${selectedTipe.kode_perkiraan}] ${namaTransaksi}`,
      nominal: nominal,
      sumber: "Lainnya",
      kode_perkiraan: selectedTipe.kode_perkiraan,
      nama_perkiraan: selectedTipe.nama_perkiraan || "",
      nama_transaksi: namaTransaksi,
    };

    setAlokasi((prev) => [...prev, newItem]);
    setSelectedTipe(null);
    setNamaTransaksi("");
    setNominalLainnya("");
    setSnackbar({
      open: true,
      message: `"${namaTransaksi}" ditambahkan ke alokasi.`,
      severity: "success",
    });
  };

  const handleHapusDariAlokasi = (itemId) => {
    setAlokasi((prev) => prev.filter((item) => item.id !== itemId));
  };

  const handleCatatPendapatanLainnya = () => {
    if (!namaPendapatan.trim()) {
      setSnackbar({
        open: true,
        message: "Masukkan keterangan / sumber pendapatan.",
        severity: "warning",
      });
      return;
    }
    const nominal = parseInt(nominalPendapatan.replace(/\D/g, ""), 10);
    if (!nominal || nominal <= 0) {
      setSnackbar({
        open: true,
        message: "Masukkan nominal yang valid.",
        severity: "warning",
      });
      return;
    }

    const newItem = {
      id: Date.now(),
      keterangan: selectedTipePendapatan
        ? `[${selectedTipePendapatan.kode_perkiraan}] ${namaPendapatan}`
        : namaPendapatan,
      nominal: nominal,
      sumber: "Pendapatan",
      kode_perkiraan: selectedTipePendapatan?.kode_perkiraan || null,
      nama_perkiraan: selectedTipePendapatan?.nama_perkiraan || "",
      nama_transaksi: namaPendapatan,
      tipe: "pemasukan",
      status: "realisasi",
      catatan: "Pendapatan selain setoran",
    };

    setAlokasi((prev) => [...prev, newItem]);
    setNamaPendapatan("");
    setNominalPendapatan("");
    setSelectedTipePendapatan(null);
    setSnackbar({
      open: true,
      message: `"${namaPendapatan}" ditambahkan ke daftar alokasi.`,
      severity: "success",
    });
  };

  const handleEditAlokasi = (item) => {
    setAlokasi((prev) => prev.filter((i) => i.id !== item.id));

    if (item.sumber === "Terdaftar") {
      const found = list_transaksi.find(
        (t) => t.no_bukti_penerimaan === item.keterangan.split(" - ")[0],
      );
      setSelectedTransaksi(found || null);
      setNominalBayar(item.nominal.toLocaleString("id-ID"));
      setTabValue(0);
    } else if (item.sumber === "Pendapatan") {
      const match = item.keterangan.match(/^\[(.+?)\]\s*(.*)$/);
      if (match) {
        const tipeLabel = match[1];
        const nama = match[2];
        const foundTipe = list_perkiraan.find(
          (t) => t.kode_perkiraan === tipeLabel,
        );
        setSelectedTipePendapatan(foundTipe || { kode_perkiraan: tipeLabel });
        setNamaPendapatan(nama);
      } else {
        setSelectedTipePendapatan(null);
        setNamaPendapatan(item.keterangan);
      }
      setNominalPendapatan(item.nominal.toLocaleString("id-ID"));
    } else {
      const match = item.keterangan.match(/^\[(.+?)\]\s*(.*)$/);
      if (match) {
        const tipeLabel = match[1];
        const nama = match[2];
        const foundTipe = list_perkiraan.find(
          (t) => t.kode_perkiraan === tipeLabel,
        );
        setSelectedTipe(foundTipe || { kode_perkiraan: tipeLabel });
        setNamaTransaksi(nama);
      } else {
        setSelectedTipe(null);
        setNamaTransaksi(item.keterangan);
      }
      setNominalLainnya(item.nominal.toLocaleString("id-ID"));
      setTabValue(1);
    }

    setSnackbar({
      open: true,
      message: "Item dikembalikan ke form untuk diedit.",
      severity: "info",
    });
  };

  const handleProsesAlokasi = async () => {
    if (alokasi.length === 0) {
      setSnackbar({
        open: true,
        message: "Alokasi masih kosong.",
        severity: "warning",
      });
      return;
    }

    const requests = alokasi.map((item) => {
      if (item.sumber === "Terdaftar") {
        return {
          nama: `Pembayaran Kontrabon ${item.no_bukti}`,
          tanggal_setoran: moment(tanggalAlokasi).format(),
          nominal: item.nominal,
          no_bukti: item.no_bukti,
          catatan: `Pembayaran Kontrabon`,
        };
      } else {
        const req = {
          nama: item.nama_transaksi || item.keterangan,
          tanggal_setoran: moment(tanggalAlokasi).format(),
          nominal: item.nominal,
          kode_perkiraan: item.kode_perkiraan,
          catatan: item.catatan || item.nama_transaksi || item.keterangan,
        };
        if (item.tipe) req.tipe = item.tipe;
        if (item.status) req.status = item.status;
        return req;
      }
    });

    await dispatch(postListTransaksiWarkat(requests));
  };

  const handleNominalChange = (setter) => (e) => {
    const raw = e.target.value.replace(/\D/g, "");
    if (raw === "") {
      setter("");
      return;
    }
    const formatted = parseInt(raw, 10).toLocaleString("id-ID");
    setter(formatted);
  };
  const cardStyle = {
    p: 3,
    borderRadius: "12px",
    backgroundColor: theme.palette.background.alt,
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    transition: "box-shadow 0.2s ease",
    "&:hover": {
      boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    },
  };
  const styles = {
    btnRealisasi: {
      ml: 1,
      borderRadius: 8,
      fontSize: 12,
      color: "#FFF",
      backgroundColor: "rgb(32, 164, 80)",
      "&:hover": {
        backgroundColor: "rgb(32, 164, 80)",
      },
    },
    btnHapus: {
      ml: 1,
      borderRadius: 8,
      fontSize: 12,
      color: "#ffff",
      backgroundColor: "#f6041c",
      "&:hover": {
        backgroundColor: "#f6041c",
      },
    },
    btnUbah: {
      ml: 1,
      borderRadius: 8,
      fontSize: 12,
      color: "#FFF",
      backgroundColor: theme.palette.primary.dark,
      padding: "4px 8px",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  };

  const statCardStyle = {
    ...cardStyle,
    display: "flex",
    flexDirection: "column",
    gap: 1,
  };

  return (
    <Box m="1.5rem 2.5rem" pb="2rem">
      <Header title="Alokasi DC" subtitle="Kelola alokasi keuangan DC." />

      <Box mt="2rem">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb="1rem"
        >
          <Typography
            variant="h5"
            fontWeight="600"
            color={theme.palette.secondary[100]}
            display="flex"
            alignItems="center"
            gap={1}
          >
            <AccountBalanceWalletOutlined /> Informasi Alokasi DC
          </Typography>

          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "15px" }}>
              <DatePicker
                label="Tanggal Mulai"
                value={startDate}
                onChange={(newValue) => setStartDate(newValue)}
                maxDate={endDate}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                    sx: {
                      width: 170,
                      backgroundColor: theme.palette.background.alt,
                      borderRadius: "8px",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        "& fieldset": { borderColor: "transparent" },
                        "&:hover fieldset": {
                          borderColor: theme.palette.secondary[500],
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: theme.palette.secondary[500],
                          borderWidth: "1px",
                        },
                      },
                    },
                  },
                }}
              />
              <Typography variant="h6" color={theme.palette.secondary[300]}>
                -
              </Typography>
              <DatePicker
                label="Tanggal Akhir"
                value={endDate}
                onChange={(newValue) => setEndDate(newValue)}
                minDate={startDate}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                    sx: {
                      width: 170,
                      backgroundColor: theme.palette.background.alt,
                      borderRadius: "8px",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        "& fieldset": { borderColor: "transparent" },
                        "&:hover fieldset": {
                          borderColor: theme.palette.secondary[500],
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: theme.palette.secondary[500],
                          borderWidth: "1px",
                        },
                      },
                    },
                  },
                }}
              />
            </Box>
          </LocalizationProvider>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <Paper
              sx={{
                ...statCardStyle,
                borderTop: "4px solid #4caf50",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 24px rgba(76, 175, 80, 0.15)",
                },
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Box
                  sx={{
                    p: 1,
                    borderRadius: "10px",
                    backgroundColor: "rgba(76, 175, 80, 0.1)",
                  }}
                >
                  <TrendingUpOutlined sx={{ color: "#4caf50" }} />
                </Box>
                <Typography
                  variant="body2"
                  fontWeight="600"
                  color={theme.palette.text.secondary}
                >
                  Pendapatan
                </Typography>
              </Box>
              <Typography variant="h3" fontWeight="bold" color="#4caf50" mt={2}>
                {formatRupiah(kasInfo.pendapatan)}
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Paper
              sx={{
                ...statCardStyle,
                borderTop: "4px solid #2196f3",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 24px rgba(33, 150, 243, 0.15)",
                },
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Box
                  sx={{
                    p: 1,
                    borderRadius: "10px",
                    backgroundColor: "rgba(33, 150, 243, 0.1)",
                  }}
                >
                  <AccountBalanceWalletOutlined sx={{ color: "#2196f3" }} />
                </Box>
                <Typography
                  variant="body2"
                  fontWeight="600"
                  color={theme.palette.text.secondary}
                >
                  Alokasi Pengeluaran
                </Typography>
              </Box>
              <Typography variant="h3" fontWeight="bold" color="#2196f3" mt={2}>
                {formatRupiah(kasInfo.alokasi)}
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Paper
              sx={{
                ...statCardStyle,
                borderTop: "4px solid #f44336",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 24px rgba(244, 67, 54, 0.15)",
                },
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Box
                  sx={{
                    p: 1,
                    borderRadius: "10px",
                    backgroundColor: "rgba(244, 67, 54, 0.1)",
                  }}
                >
                  <TrendingDownOutlined sx={{ color: "#f44336" }} />
                </Box>
                <Typography
                  variant="body2"
                  fontWeight="600"
                  color={theme.palette.text.secondary}
                >
                  Realisasi Pengeluaran
                </Typography>
              </Box>
              <Typography variant="h3" fontWeight="bold" color="#f44336" mt={2}>
                {formatRupiah(kasInfo.pengeluaran)}
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Paper
              sx={{
                ...statCardStyle,
                borderTop: "4px solid #009688",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 8px 24px rgba(0, 150, 136, 0.15)",
                },
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Box
                  sx={{
                    p: 1,
                    borderRadius: "10px",
                    backgroundColor: "rgba(0, 150, 136, 0.1)",
                  }}
                >
                  <AccountBalanceOutlined sx={{ color: "#009688" }} />
                </Box>
                <Typography
                  variant="body2"
                  fontWeight="600"
                  color={theme.palette.text.secondary}
                >
                  Saldo
                </Typography>
              </Box>
              <Typography variant="h3" fontWeight="bold" color="#009688" mt={2}>
                {formatRupiah(kasInfo.pendapatan - kasInfo.pengeluaran)}
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      <Box mt="3rem">
        <Typography
          variant="h4"
          fontWeight="700"
          mb="1.5rem"
          display="flex"
          alignItems="center"
          gap={1.5}
          sx={{
            background: `linear-gradient(45deg, ${theme.palette.secondary[100]}, ${theme.palette.secondary[400]})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            textShadow: "0px 2px 10px rgba(0,0,0,0.1)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 1,
              borderRadius: "12px",
              background: `linear-gradient(135deg, ${theme.palette.secondary[500]}20, ${theme.palette.secondary[500]}50)`,
              boxShadow: `0 4px 12px ${theme.palette.secondary[500]}20`,
            }}
          >
            <ReceiptLongOutlined
              sx={{ color: theme.palette.secondary[300], fontSize: "1.8rem" }}
            />
          </Box>
          Riwayat Alokasi Keuangan DC
        </Typography>

        <Paper
          elevation={0}
          sx={{
            ...cardStyle,
            p: 0,
            overflow: "hidden",
            borderRadius: "20px",
            border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"}`,
            boxShadow:
              theme.palette.mode === "dark"
                ? "0 8px 32px rgba(0,0,0,0.4)"
                : "0 8px 32px rgba(0,0,0,0.08)",
            background:
              theme.palette.mode === "dark"
                ? "linear-gradient(145deg, #1e1e1e, #2a2a2a)"
                : "#ffffff",
          }}
        >
          <TableContainer
            sx={{
              maxHeight: 600,
              "&::-webkit-scrollbar": { width: "8px", height: "8px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor:
                  theme.palette.mode === "dark"
                    ? "rgba(255,255,255,0.2)"
                    : "rgba(0,0,0,0.2)",
                borderRadius: "10px",
              },
            }}
          >
            <Table stickyHeader size="medium" sx={{ minWidth: 800 }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: "700",
                      backgroundColor:
                        theme.palette.mode === "dark" ? "#222" : "#f8f9fa",
                      fontSize: "14px",
                      width: 40,
                      borderBottom: `2px solid ${theme.palette.mode === "dark" ? "#333" : "#eee"}`,
                    }}
                  />

                  <TableCell
                    sx={{
                      fontWeight: "700",
                      backgroundColor:
                        theme.palette.mode === "dark" ? "#222" : "#f8f9fa",
                      fontSize: "14px",
                      color: theme.palette.text.secondary,
                      borderBottom: `2px solid ${theme.palette.mode === "dark" ? "#333" : "#eee"}`,
                    }}
                  >
                    Tanggal Setoran
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "700",
                      backgroundColor:
                        theme.palette.mode === "dark" ? "#222" : "#f8f9fa",
                      fontSize: "14px",
                      color: theme.palette.text.secondary,
                      borderBottom: `2px solid ${theme.palette.mode === "dark" ? "#333" : "#eee"}`,
                    }}
                  >
                    Keterangan
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "700",
                      backgroundColor:
                        theme.palette.mode === "dark" ? "#222" : "#f8f9fa",
                      fontSize: "14px",
                      color: theme.palette.text.secondary,
                      borderBottom: `2px solid ${theme.palette.mode === "dark" ? "#333" : "#eee"}`,
                    }}
                    align="center"
                  >
                    Tipe
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "700",
                      backgroundColor:
                        theme.palette.mode === "dark" ? "#222" : "#f8f9fa",
                      fontSize: "14px",
                      color: theme.palette.text.secondary,
                      borderBottom: `2px solid ${theme.palette.mode === "dark" ? "#333" : "#eee"}`,
                    }}
                    align="center"
                  >
                    Status
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "700",
                      backgroundColor:
                        theme.palette.mode === "dark" ? "#222" : "#f8f9fa",
                      fontSize: "14px",
                      color: theme.palette.text.secondary,
                      borderBottom: `2px solid ${theme.palette.mode === "dark" ? "#333" : "#eee"}`,
                    }}
                    align="right"
                  >
                    Nominal
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "700",
                      backgroundColor:
                        theme.palette.mode === "dark" ? "#222" : "#f8f9fa",
                      fontSize: "14px",
                      color: theme.palette.text.secondary,
                      borderBottom: `2px solid ${theme.palette.mode === "dark" ? "#333" : "#eee"}`,
                    }}
                    align="right"
                  >
                    Aksi
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {riwayatGrouped.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 10 }}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        sx={{ opacity: 0.6 }}
                      >
                        <ReceiptLongOutlined
                          sx={{ fontSize: 72, mb: 2, opacity: 0.3 }}
                        />
                        <Typography
                          variant="h6"
                          fontWeight="600"
                          color={theme.palette.text.secondary}
                        >
                          Belum Ada Riwayat Alokasi Keuangan DC
                        </Typography>
                        <Typography
                          variant="body2"
                          color={theme.palette.text.secondary}
                          mt={1}
                        >
                          Tidak ada Riwayat Alokasi Keuangan DC yang ditemukan
                          untuk rentang tanggal yang dipilih.
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  riwayatGrouped.map((row) => {
                    const hasItems = row.items && row.items.length > 0;
                    const isExpanded = !!expandedRows[row.id];
                    const showCetakButton = (() => {
                      if (row.tipe !== "pengeluaran") return false;
                      const items =
                        row.items || (row.singleItem ? [row.singleItem] : []);
                      return items.some((item) => item.status === "alokasi");
                    })();

                    const hasDataSetoranSingle =
                      !!row.singleItem?.data_setoran?.list_pengeluaran;

                    const totalUangCashSingle = hasDataSetoranSingle
                      ? Number(
                          row.singleItem?.data_setoran
                            ?.total_setoran_cash_akumulasi || 0,
                        ) -
                        Number(
                          row.singleItem?.data_setoran?.total_transfer || 0,
                        ) +
                        Number(
                          row.singleItem?.data_setoran?.list_pengeluaran
                            ?.nominal_pendapatan || 0,
                        )
                      : Number(
                          row.singleItem?.data_setoran
                            ?.total_setoran_cash_akumulasi || 0,
                        ) +
                        Math.abs(
                          Number(
                            row.singleItem?.data_setoran
                              ?.total_selisih_murni_akumulasi_kondisi || 0,
                          ),
                        );

                    const totalUangTransferSingle = hasDataSetoranSingle
                      ? Number(
                          row.singleItem?.data_setoran?.list_pengeluaran
                            ?.transfer_pendapatan || 0,
                        ) +
                        Number(
                          row.singleItem?.data_setoran?.total_transfer || 0,
                        )
                      : Number(
                          row.singleItem?.data_setoran?.total_transfer || 0,
                        );
                    return (
                      <React.Fragment key={row.id}>
                        <TableRow
                          sx={{
                            "&:hover": {
                              backgroundColor:
                                theme.palette.mode === "dark"
                                  ? "rgba(255,255,255,0.03)"
                                  : "rgba(0,0,0,0.015)",
                            },
                            transition: "all 0.2s ease",
                            cursor: hasItems ? "pointer" : "default",
                            ...(isExpanded && {
                              backgroundColor:
                                theme.palette.mode === "dark"
                                  ? "rgba(255,255,255,0.02)"
                                  : "rgba(0,0,0,0.01)",
                              "& td": { borderBottom: "none" },
                            }),
                          }}
                          onClick={() => {
                            if (hasItems) {
                              setExpandedRows((prev) => ({
                                [row.id]: !prev[row.id],
                              }));
                              setSearchSubItemText("");
                            }
                          }}
                        >
                          <TableCell sx={{ width: 40, p: 1 }}>
                            {hasItems && (
                              <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setExpandedRows((prev) => ({
                                    ...prev,
                                    [row.id]: !prev[row.id],
                                  }));
                                  setSearchSubItemText("");
                                }}
                                sx={{ p: 0.5 }}
                              >
                                <KeyboardArrowDown
                                  sx={{
                                    transform: isExpanded
                                      ? "rotate(180deg)"
                                      : "rotate(0deg)",
                                    transition: "transform 0.2s ease",
                                  }}
                                />
                              </IconButton>
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontSize: "14px",
                              fontWeight: "600",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {moment(row.tanggal_setoran).format("DD MMM YYYY")}
                          </TableCell>
                          <TableCell sx={{ fontSize: "14px" }}>
                            <Box
                              display="flex"
                              flexDirection="column"
                              gap={0.5}
                            >
                              <Box
                                display="flex"
                                alignItems="center"
                                gap={1.5}
                                sx={{
                                  cursor:
                                    !hasItems &&
                                    row.keterangan ===
                                      "Setoran Tunai Harian Cabang"
                                      ? "pointer"
                                      : "default",
                                }}
                                onClick={(e) => {
                                  if (
                                    !hasItems &&
                                    row.keterangan ===
                                      "Setoran Tunai Harian Cabang"
                                  ) {
                                    e.stopPropagation();
                                    setExpandedRows((prev) => ({
                                      ...prev,
                                      [row.id]: !prev[row.id],
                                    }));
                                  }
                                }}
                              >
                                <Typography variant="body2" fontWeight="500">
                                  {row.keterangan}
                                </Typography>
                                {hasItems && (
                                  <Chip
                                    label={`${row.items.length} item`}
                                    size="small"
                                    sx={{
                                      fontSize: "11px",
                                      height: 22,
                                      fontWeight: 700,
                                      backgroundColor:
                                        theme.palette.mode === "dark"
                                          ? "rgba(255,255,255,0.1)"
                                          : "rgba(0,0,0,0.06)",
                                      color: theme.palette.text.secondary,
                                    }}
                                  />
                                )}
                                {!hasItems &&
                                  row.keterangan ===
                                    "Setoran Tunai Harian Cabang" && (
                                    <KeyboardArrowDown
                                      fontSize="small"
                                      sx={{
                                        transform: isExpanded
                                          ? "rotate(180deg)"
                                          : "rotate(0deg)",
                                        transition: "transform 0.2s ease",
                                        opacity: 0.7,
                                      }}
                                    />
                                  )}
                              </Box>

                              {!hasItems &&
                                row.keterangan ===
                                  "Setoran Tunai Harian Cabang" && (
                                  <Collapse
                                    in={isExpanded}
                                    timeout="auto"
                                    unmountOnExit
                                  >
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      gap={0.5}
                                      mt={0.5}
                                    >
                                      {row.singleItem?.catatan &&
                                        row.singleItem.catatan !==
                                          row.keterangan && (
                                          <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 0.5,
                                            }}
                                          >
                                            <span style={{ opacity: 0.5 }}>
                                              •
                                            </span>
                                            Catatan: {row.singleItem.catatan}
                                          </Typography>
                                        )}
                                      {row.singleItem?.data_setoran && (
                                        <>
                                          <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 0.5,
                                            }}
                                          >
                                            <span style={{ opacity: 0.5 }}>
                                              •
                                            </span>
                                            {`Tunai: ${formatRupiah(
                                              totalUangCashSingle,
                                            )}`}
                                          </Typography>
                                          <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 0.5,
                                            }}
                                          >
                                            <span style={{ opacity: 0.5 }}>
                                              •
                                            </span>
                                            {`Transfer: ${formatRupiah(
                                              totalUangTransferSingle,
                                            )}`}
                                          </Typography>
                                          <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 0.5,
                                            }}
                                          >
                                            <span style={{ opacity: 0.5 }}>
                                              •
                                            </span>
                                            {`EDC Machine: ${formatRupiah(
                                              Number(
                                                row?.singleItem?.data_setoran
                                                  .total_debit_credit_akumulasi ??
                                                  0,
                                              ),
                                            )}`}
                                          </Typography>
                                          <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 0.5,
                                            }}
                                          >
                                            <span style={{ opacity: 0.5 }}>
                                              •
                                            </span>
                                            {`QRIS: ${formatRupiah(
                                              Number(
                                                row.singleItem.data_setoran
                                                  .total_ewallet_akumulasi,
                                              ),
                                            )}`}
                                          </Typography>
                                        </>
                                      )}
                                    </Box>
                                  </Collapse>
                                )}
                            </Box>
                          </TableCell>
                          <TableCell align="center">
                            <Chip
                              label={
                                row.tipe === "pemasukan"
                                  ? "Pemasukan"
                                  : "Pengeluaran"
                              }
                              size="small"
                              sx={{
                                fontWeight: 700,
                                fontSize: "12px",
                                color:
                                  row.tipe === "pemasukan"
                                    ? "#2e7d32"
                                    : "#d32f2f",
                                backgroundColor:
                                  row.tipe === "pemasukan"
                                    ? "rgba(76, 175, 80, 0.15)"
                                    : "rgba(244, 67, 54, 0.15)",
                                border: `1px solid ${row.tipe === "pemasukan" ? "rgba(76, 175, 80, 0.3)" : "rgba(244, 67, 54, 0.3)"}`,
                                minWidth: 80,
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {!(row.tipe === "pengeluaran" && hasItems) && (
                              <Chip
                                label={
                                  row.status === "alokasi"
                                    ? "Alokasi"
                                    : "Realisasi"
                                }
                                size="small"
                                sx={{
                                  fontWeight: 700,
                                  fontSize: "12px",
                                  color:
                                    row.status === "alokasi"
                                      ? theme.palette.mode === "dark"
                                        ? "#aaa"
                                        : "#555"
                                      : "#1976d2",
                                  backgroundColor:
                                    row.status === "alokasi"
                                      ? theme.palette.mode === "dark"
                                        ? "rgba(255,255,255,0.1)"
                                        : "rgba(0,0,0,0.06)"
                                      : "rgba(25, 118, 210, 0.15)",
                                  border: `1px solid ${row.status === "alokasi" ? "transparent" : "rgba(25, 118, 210, 0.3)"}`,
                                  minWidth: 80,
                                }}
                              />
                            )}
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              fontSize: "15px",
                              fontWeight: 700,
                              color:
                                row.tipe === "pemasukan"
                                  ? "#2e7d32"
                                  : "#d32f2f",
                            }}
                          >
                            {row.tipe === "pemasukan" ? "+ " : "- "}
                            {formatRupiah(row.nominal)}
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {/* {row.tipe === "pemasukan" &&
                              row.status === "realisasi" &&
                              row.keterangan ===
                                "Setoran Tunai Harian Cabang" && (
                                <IconButton
                                  size="small"
                                  sx={{
                                    color: "#9c27b0",
                                    backgroundColor: "rgba(156, 39, 176, 0.08)",
                                    borderRadius: "8px",
                                    "&:hover": {
                                      backgroundColor:
                                        "rgba(156, 39, 176, 0.15)",
                                    },
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenDetailSetoranCabang(
                                      row.singleItem,
                                    );
                                  }}
                                  title="Lihat Detail Setoran"
                                >
                                  <VisibilityOutlined fontSize="small" />
                                </IconButton>
                              )} */}
                            {showCetakButton && (
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handlePrintAlokasi(row);
                                }}
                                startIcon={<PrintOutlined />}
                                sx={{
                                  ml: 1,
                                  borderRadius: "8px",
                                  textTransform: "none",
                                  fontWeight: 600,
                                  fontSize: "12px",
                                  borderColor: theme.palette.info.main,
                                  color: theme.palette.info.main,
                                  "&:hover": {
                                    backgroundColor: "rgba(2, 136, 209, 0.08)",
                                  },
                                }}
                              >
                                Cetak
                              </Button>
                            )}

                            {row.tipe === "pengeluaran" &&
                              row.status === "alokasi" &&
                              !hasItems && (
                                <>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      let ids = [row.singleItem.id];
                                      dispatch(
                                        realisasiListTransaksiWarkat({ ids }),
                                      );
                                    }}
                                    startIcon={<CheckBoxOutlined />}
                                    sx={{
                                      ml: 1,
                                      borderRadius: "8px",
                                      textTransform: "none",
                                      fontWeight: 600,
                                      fontSize: "12px",
                                      backgroundColor: "#4caf50",
                                      boxShadow:
                                        "0 2px 6px rgba(76, 175, 80, 0.3)",
                                      "&:hover": {
                                        backgroundColor: "#43a047",
                                        boxShadow:
                                          "0 4px 8px rgba(76, 175, 80, 0.4)",
                                      },
                                      color: "white",
                                    }}
                                  >
                                    Realisasi
                                  </Button>

                                  {!hasItems && (
                                    <>
                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedTransaksi(row.singleItem);
                                          setOpenKonfirmasi(true);
                                        }}
                                        sx={{
                                          ml: 1,
                                          color: "#d32f2f",
                                          backgroundColor:
                                            "rgba(211, 47, 47, 0.08)",
                                          borderRadius: "8px",
                                          "&:hover": {
                                            backgroundColor:
                                              "rgba(211, 47, 47, 0.15)",
                                          },
                                        }}
                                        title="Hapus"
                                      >
                                        <DeleteOutline fontSize="small" />
                                      </IconButton>

                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedTransaksi(row.singleItem);
                                          setTanggalPengganti(
                                            moment(row.tanggal_setoran),
                                          );
                                          setOpenUbahTanggal(true);
                                        }}
                                        sx={{
                                          ml: 1,
                                          color: "#1976d2",
                                          backgroundColor:
                                            "rgba(25, 118, 210, 0.08)",
                                          borderRadius: "8px",
                                          "&:hover": {
                                            backgroundColor:
                                              "rgba(25, 118, 210, 0.15)",
                                          },
                                        }}
                                        title="Ubah Tanggal"
                                      >
                                        <CalendarMonthOutlined fontSize="small" />
                                      </IconButton>
                                    </>
                                  )}
                                </>
                              )}
                          </TableCell>
                        </TableRow>

                        {/* ── Expandable sub-items ─── */}
                        {hasItems && (
                          <TableRow>
                            <TableCell
                              colSpan={7}
                              sx={{
                                p: 0,
                                borderBottom: isExpanded
                                  ? `1px solid ${theme.palette.mode === "dark" ? "#333" : "#eee"}`
                                  : "none",
                              }}
                            >
                              <Collapse
                                in={isExpanded}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Box
                                  sx={{
                                    py: 2,
                                    px: 3,
                                    ml: { xs: 2, md: 6 },
                                    mr: { xs: 2, md: 4 },
                                    my: 2,
                                    borderRadius: "12px",
                                    backgroundColor:
                                      theme.palette.mode === "dark"
                                        ? "rgba(0,0,0,0.2)"
                                        : "#fafafa",
                                    border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.04)"}`,
                                    boxShadow:
                                      "inset 0 2px 4px rgba(0,0,0,0.02)",
                                  }}
                                >
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    mb={2}
                                    sx={{
                                      flexDirection: {
                                        xs: "column",
                                        sm: "row",
                                      },
                                      gap: { xs: 1.5, sm: 2 },
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      fontWeight="700"
                                      color={
                                        row.tipe === "pemasukan"
                                          ? "#2e7d32"
                                          : "#d32f2f"
                                      }
                                      sx={{
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px",
                                        alignSelf: {
                                          xs: "flex-start",
                                          sm: "center",
                                        },
                                      }}
                                    >
                                      Detail{" "}
                                      {row.tipe === "pemasukan"
                                        ? "Pemasukan"
                                        : "Pengeluaran"}
                                    </Typography>

                                    <TextField
                                      placeholder={`Cari detail ${row.tipe === "pemasukan" ? "pemasukan" : "pengeluaran"}...`}
                                      size="small"
                                      value={searchSubItemText}
                                      onChange={(e) =>
                                        setSearchSubItemText(e.target.value)
                                      }
                                      InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <Search
                                              sx={{
                                                color: "text.secondary",
                                                fontSize: "18px",
                                              }}
                                            />
                                          </InputAdornment>
                                        ),
                                        endAdornment: searchSubItemText && (
                                          <InputAdornment position="end">
                                            <IconButton
                                              size="small"
                                              onClick={() =>
                                                setSearchSubItemText("")
                                              }
                                              sx={{ p: 0.5 }}
                                            >
                                              <CloseIcon
                                                sx={{ fontSize: "14px" }}
                                              />
                                            </IconButton>
                                          </InputAdornment>
                                        ),
                                      }}
                                      sx={{
                                        width: { xs: "100%", sm: 280 },
                                        backgroundColor:
                                          theme.palette.mode === "dark"
                                            ? "rgba(255,255,255,0.05)"
                                            : "#ffffff",
                                        borderRadius: "8px",
                                        "& .MuiOutlinedInput-root": {
                                          borderRadius: "8px",
                                          "& fieldset": {
                                            borderColor:
                                              theme.palette.mode === "dark"
                                                ? "rgba(255,255,255,0.1)"
                                                : "rgba(0,0,0,0.1)",
                                          },
                                          "&:hover fieldset": {
                                            borderColor:
                                              row.tipe === "pemasukan"
                                                ? "#2e7d32"
                                                : "#d32f2f",
                                          },
                                          "&.Mui-focused fieldset": {
                                            borderColor:
                                              row.tipe === "pemasukan"
                                                ? "#2e7d32"
                                                : "#d32f2f",
                                            borderWidth: "1.5px",
                                          },
                                        },
                                        "& .MuiInputBase-input": {
                                          py: 0.8,
                                          fontSize: "12px",
                                        },
                                      }}
                                    />
                                  </Box>
                                  {(() => {
                                    const filteredItems = row.items.filter(
                                      (subItem) => {
                                        if (!searchSubItemText) return true;
                                        const lowerQuery =
                                          searchSubItemText.toLowerCase();
                                        const namaMatch = subItem.nama
                                          ?.toLowerCase()
                                          .includes(lowerQuery);
                                        const catatanMatch = subItem.catatan
                                          ?.toLowerCase()
                                          .includes(lowerQuery);
                                        const supplierMatch =
                                          subItem.nama_supplier
                                            ?.toLowerCase()
                                            .includes(lowerQuery);
                                        const perkiraanMatch =
                                          subItem.nama_perkiraan
                                            ?.toLowerCase()
                                            .includes(lowerQuery);
                                        const nominalMatch =
                                          subItem.nominal
                                            ?.toString()
                                            .includes(lowerQuery) ||
                                          formatRupiah(
                                            Number(subItem.nominal) || 0,
                                          )
                                            .toLowerCase()
                                            .includes(lowerQuery);
                                        return (
                                          namaMatch ||
                                          catatanMatch ||
                                          supplierMatch ||
                                          perkiraanMatch ||
                                          nominalMatch
                                        );
                                      },
                                    );

                                    if (filteredItems.length === 0) {
                                      return (
                                        <Box
                                          display="flex"
                                          flexDirection="column"
                                          alignItems="center"
                                          justifyContent="center"
                                          sx={{ py: 4, opacity: 0.6 }}
                                        >
                                          <Typography
                                            variant="body2"
                                            color="text.secondary"
                                          >
                                            Tidak ada detail item yang cocok
                                            dengan pencarian "
                                            {searchSubItemText}"
                                          </Typography>
                                        </Box>
                                      );
                                    }

                                    // Group filtered items by waktu
                                    const timeGroups = {};
                                    filteredItems.forEach((subItem) => {
                                      let timeKey = "Lainnya";
                                      if (subItem.waktu) {
                                        const parts = subItem.waktu.split(":");
                                        if (parts.length >= 2) {
                                          timeKey = `${parts[0]}:${parts[1]}`;
                                        } else {
                                          timeKey = subItem.waktu;
                                        }
                                      }
                                      if (!timeGroups[timeKey]) {
                                        timeGroups[timeKey] = [];
                                      }
                                      timeGroups[timeKey].push(subItem);
                                    });

                                    // Sort time groups in descending order (latest first)
                                    const sortedTimes = Object.keys(
                                      timeGroups,
                                    ).sort((a, b) => {
                                      if (a === "Lainnya") return 1;
                                      if (b === "Lainnya") return -1;
                                      return b.localeCompare(a);
                                    });

                                    return sortedTimes.map(
                                      (timeKey, groupIdx) => {
                                        const itemsAtTime = timeGroups[timeKey];
                                        return (
                                          <Box
                                            key={timeKey}
                                            sx={{
                                              mb:
                                                groupIdx <
                                                sortedTimes.length - 1
                                                  ? 3
                                                  : 0,
                                            }}
                                          >
                                            {/* Time header divider */}
                                            <Box
                                              display="flex"
                                              alignItems="center"
                                              gap={1}
                                              mb={1.5}
                                              mt={groupIdx === 0 ? 0 : 2}
                                            >
                                              <AccessTimeOutlined
                                                sx={{
                                                  fontSize: "16px",
                                                  color:
                                                    theme.palette.text
                                                      .secondary,
                                                  opacity: 0.8,
                                                }}
                                              />
                                              <Typography
                                                variant="subtitle2"
                                                fontWeight="700"
                                                color={
                                                  theme.palette.text.secondary
                                                }
                                                sx={{
                                                  fontSize: "12px",
                                                  letterSpacing: "0.5px",
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                {timeKey === "Lainnya"
                                                  ? "Waktu Tidak Ditentukan"
                                                  : `Pukul ${timeKey}`}
                                              </Typography>
                                              <Divider
                                                sx={{
                                                  flex: 1,
                                                  borderColor:
                                                    theme.palette.mode ===
                                                    "dark"
                                                      ? "rgba(255,255,255,0.08)"
                                                      : "rgba(0,0,0,0.06)",
                                                }}
                                              />
                                              {row.tipe === "pengeluaran" &&
                                                (() => {
                                                  const isGroupAlokasi =
                                                    itemsAtTime.some(
                                                      (item) =>
                                                        item.status ===
                                                        "alokasi",
                                                    );
                                                  return (
                                                    <Box
                                                      display="flex"
                                                      alignItems="center"
                                                      gap={1}
                                                    >
                                                      <Chip
                                                        label={
                                                          isGroupAlokasi
                                                            ? "Alokasi"
                                                            : "Realisasi"
                                                        }
                                                        size="small"
                                                        sx={{
                                                          fontWeight: 700,
                                                          fontSize: "11px",
                                                          height: 22,
                                                          color: isGroupAlokasi
                                                            ? theme.palette
                                                                .mode === "dark"
                                                              ? "#aaa"
                                                              : "#555"
                                                            : "#1976d2",
                                                          backgroundColor:
                                                            isGroupAlokasi
                                                              ? theme.palette
                                                                  .mode ===
                                                                "dark"
                                                                ? "rgba(255,255,255,0.1)"
                                                                : "rgba(0,0,0,0.06)"
                                                              : "rgba(25, 118, 210, 0.15)",
                                                          border: `1px solid ${isGroupAlokasi ? "transparent" : "rgba(25, 118, 210, 0.3)"}`,
                                                          minWidth: 70,
                                                        }}
                                                      />
                                                      {isGroupAlokasi && (
                                                        <Button
                                                          variant="contained"
                                                          size="small"
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            const ids =
                                                              itemsAtTime.map(
                                                                (item) =>
                                                                  item.id.toString(),
                                                              );
                                                            dispatch(
                                                              realisasiListTransaksiWarkat(
                                                                { ids },
                                                              ),
                                                            );
                                                          }}
                                                          startIcon={
                                                            <CheckBoxOutlined />
                                                          }
                                                          sx={{
                                                            borderRadius: "8px",
                                                            textTransform:
                                                              "none",
                                                            fontWeight: 600,
                                                            fontSize: "11px",
                                                            height: 24,
                                                            py: 0,
                                                            backgroundColor:
                                                              "#4caf50",
                                                            boxShadow:
                                                              "0 2px 6px rgba(76, 175, 80, 0.3)",
                                                            "&:hover": {
                                                              backgroundColor:
                                                                "#43a047",
                                                              boxShadow:
                                                                "0 4px 8px rgba(76, 175, 80, 0.4)",
                                                            },
                                                            color: "white",
                                                          }}
                                                        >
                                                          Realisasi
                                                        </Button>
                                                      )}
                                                    </Box>
                                                  );
                                                })()}
                                            </Box>

                                            <Box
                                              display="flex"
                                              flexDirection="column"
                                              gap={1}
                                            >
                                              {itemsAtTime.map(
                                                (subItem, idx) => {
                                                  const hasData =
                                                    !!subItem.data_setoran
                                                      ?.list_pengeluaran;

                                                  const totalUangCash = hasData
                                                    ? Number(
                                                        subItem?.data_setoran
                                                          ?.total_setoran_cash_akumulasi ||
                                                          0,
                                                      ) -
                                                      Number(
                                                        subItem?.data_setoran
                                                          ?.total_transfer || 0,
                                                      ) +
                                                      Number(
                                                        subItem?.data_setoran
                                                          ?.list_pengeluaran
                                                          ?.nominal_pendapatan ||
                                                          0,
                                                      )
                                                    : Number(
                                                        subItem?.data_setoran
                                                          ?.total_setoran_cash_akumulasi ||
                                                          0,
                                                      ) +
                                                      Math.abs(
                                                        Number(
                                                          subItem?.data_setoran
                                                            ?.total_selisih_murni_akumulasi_kondisi ||
                                                            0,
                                                        ),
                                                      );

                                                  const totalUangTransfer =
                                                    hasData
                                                      ? Number(
                                                          subItem?.data_setoran
                                                            ?.list_pengeluaran
                                                            ?.transfer_pendapatan ||
                                                            0,
                                                        ) +
                                                        Number(
                                                          subItem?.data_setoran
                                                            ?.total_transfer ||
                                                            0,
                                                        )
                                                      : Number(
                                                          subItem?.data_setoran
                                                            ?.total_transfer ||
                                                            0,
                                                        );

                                                  return (
                                                    <Box
                                                      key={subItem.id || idx}
                                                      display="flex"
                                                      alignItems="center"
                                                      justifyContent="space-between"
                                                      sx={{
                                                        py: 1.5,
                                                        px: 2,
                                                        mb:
                                                          idx <
                                                          itemsAtTime.length - 1
                                                            ? 1
                                                            : 0,
                                                        borderRadius: "10px",
                                                        backgroundColor:
                                                          theme.palette
                                                            .background.default,
                                                        border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"}`,
                                                        transition:
                                                          "transform 0.2s, box-shadow 0.2s",
                                                        "&:hover": {
                                                          transform:
                                                            "translateX(4px)",
                                                          boxShadow:
                                                            "0 2px 8px rgba(0,0,0,0.04)",
                                                        },
                                                      }}
                                                    >
                                                      <Box
                                                        sx={{
                                                          flex: 1,
                                                          minWidth: 0,
                                                          pr: 2,
                                                        }}
                                                      >
                                                        <Typography
                                                          variant="body2"
                                                          fontSize="13px"
                                                          fontWeight="600"
                                                          mb={0.5}
                                                        >
                                                          {subItem.nama}
                                                        </Typography>

                                                        <Box
                                                          display="flex"
                                                          flexDirection="column"
                                                          gap={0.5}
                                                        >
                                                          {subItem.catatan &&
                                                            subItem.catatan !==
                                                              subItem.nama && (
                                                              <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 0.5,
                                                                }}
                                                              >
                                                                <span
                                                                  style={{
                                                                    opacity: 0.5,
                                                                  }}
                                                                >
                                                                  •
                                                                </span>
                                                                Catatan:{" "}
                                                                {
                                                                  subItem.catatan
                                                                }
                                                              </Typography>
                                                            )}
                                                          {subItem.nama ===
                                                            "Setoran Tunai Harian Cabang" && (
                                                            <>
                                                              <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 0.5,
                                                                }}
                                                              >
                                                                <span
                                                                  style={{
                                                                    opacity: 0.5,
                                                                  }}
                                                                >
                                                                  •
                                                                </span>
                                                                {`Tunai: ${formatRupiah(
                                                                  totalUangCash,
                                                                )}`}
                                                              </Typography>
                                                              <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 0.5,
                                                                }}
                                                              >
                                                                <span
                                                                  style={{
                                                                    opacity: 0.5,
                                                                  }}
                                                                >
                                                                  •
                                                                </span>
                                                                {`Transfer: ${formatRupiah(
                                                                  totalUangTransfer,
                                                                )}`}
                                                              </Typography>
                                                              <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 0.5,
                                                                }}
                                                              >
                                                                <span
                                                                  style={{
                                                                    opacity: 0.5,
                                                                  }}
                                                                >
                                                                  •
                                                                </span>
                                                                {`EDC Machine: ${formatRupiah(
                                                                  Number(
                                                                    subItem
                                                                      ?.data_setoran
                                                                      ?.total_debit_credit_akumulasi ??
                                                                      0,
                                                                  ),
                                                                )}`}
                                                              </Typography>
                                                              <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 0.5,
                                                                }}
                                                              >
                                                                <span
                                                                  style={{
                                                                    opacity: 0.5,
                                                                  }}
                                                                >
                                                                  •
                                                                </span>
                                                                {`QRIS: ${formatRupiah(
                                                                  Number(
                                                                    subItem
                                                                      ?.data_setoran
                                                                      ?.total_ewallet_akumulasi ??
                                                                      0,
                                                                  ),
                                                                )}`}
                                                              </Typography>
                                                            </>
                                                          )}

                                                          {subItem.nama_supplier && (
                                                            <Typography
                                                              variant="caption"
                                                              color="text.secondary"
                                                              sx={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                gap: 0.5,
                                                              }}
                                                            >
                                                              <span
                                                                style={{
                                                                  opacity: 0.5,
                                                                }}
                                                              >
                                                                •
                                                              </span>{" "}
                                                              Supplier:{" "}
                                                              {
                                                                subItem.nama_supplier
                                                              }
                                                            </Typography>
                                                          )}
                                                          {subItem.nama_perkiraan && (
                                                            <Typography
                                                              variant="caption"
                                                              color="text.secondary"
                                                              sx={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                gap: 0.5,
                                                              }}
                                                            >
                                                              <span
                                                                style={{
                                                                  opacity: 0.5,
                                                                }}
                                                              >
                                                                •
                                                              </span>{" "}
                                                              Kode Perkiraan:{" "}
                                                              {
                                                                subItem.nama_perkiraan
                                                              }
                                                            </Typography>
                                                          )}
                                                        </Box>
                                                      </Box>

                                                      <Box
                                                        display="flex"
                                                        alignItems="center"
                                                        gap={2}
                                                      >
                                                        <Typography
                                                          variant="body2"
                                                          fontWeight="700"
                                                          fontSize="14px"
                                                          color={
                                                            row.tipe ===
                                                            "pemasukan"
                                                              ? "#2e7d32"
                                                              : "#d32f2f"
                                                          }
                                                          sx={{
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          {row.tipe ===
                                                          "pemasukan"
                                                            ? "+ "
                                                            : "- "}
                                                          {formatRupiah(
                                                            Number(
                                                              subItem.nominal,
                                                            ) || 0,
                                                          )}
                                                        </Typography>

                                                        <Box
                                                          display="flex"
                                                          gap={1}
                                                        >
                                                          {subItem.nama !==
                                                            "Setoran Tunai Harian Cabang" &&
                                                            subItem.status ===
                                                              "alokasi" && (
                                                              <>
                                                                <IconButton
                                                                  size="small"
                                                                  onClick={() => {
                                                                    setSelectedTransaksi(
                                                                      subItem,
                                                                    );
                                                                    setOpenKonfirmasi(
                                                                      true,
                                                                    );
                                                                  }}
                                                                  sx={{
                                                                    color:
                                                                      "#d32f2f",
                                                                    backgroundColor:
                                                                      "rgba(211, 47, 47, 0.08)",
                                                                    borderRadius:
                                                                      "8px",
                                                                    "&:hover": {
                                                                      backgroundColor:
                                                                        "rgba(211, 47, 47, 0.15)",
                                                                    },
                                                                  }}
                                                                  title="Hapus"
                                                                >
                                                                  <DeleteOutline fontSize="small" />
                                                                </IconButton>
                                                                <IconButton
                                                                  size="small"
                                                                  onClick={() => {
                                                                    setSelectedTransaksi(
                                                                      subItem,
                                                                    );
                                                                    setTanggalPengganti(
                                                                      moment(
                                                                        subItem.tanggal_setoran,
                                                                      ),
                                                                    );
                                                                    setOpenUbahTanggal(
                                                                      true,
                                                                    );
                                                                  }}
                                                                  sx={{
                                                                    color:
                                                                      "#1976d2",
                                                                    backgroundColor:
                                                                      "rgba(25, 118, 210, 0.08)",
                                                                    borderRadius:
                                                                      "8px",
                                                                    "&:hover": {
                                                                      backgroundColor:
                                                                        "rgba(25, 118, 210, 0.15)",
                                                                    },
                                                                  }}
                                                                  title="Ubah Tanggal"
                                                                >
                                                                  <CalendarMonthOutlined fontSize="small" />
                                                                </IconButton>
                                                              </>
                                                            )}
                                                        </Box>
                                                      </Box>
                                                    </Box>
                                                  );
                                                },
                                              )}
                                            </Box>
                                          </Box>
                                        );
                                      },
                                    );
                                  })()}
                                </Box>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
      <Box mt="3rem">
        <Typography
          variant="h4"
          fontWeight="700"
          mb="1.5rem"
          display="flex"
          alignItems="center"
          gap={1.5}
          sx={{
            background: `linear-gradient(45deg, ${theme.palette.secondary[100]}, ${theme.palette.secondary[400]})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            textShadow: "0px 2px 10px rgba(0,0,0,0.1)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 1,
              borderRadius: "12px",
              background: `linear-gradient(135deg, ${theme.palette.secondary[500]}20, ${theme.palette.secondary[500]}50)`,
              boxShadow: `0 4px 12px ${theme.palette.secondary[500]}20`,
            }}
          >
            <AddCircleOutline
              sx={{ color: theme.palette.secondary[300], fontSize: "1.8rem" }}
            />
          </Box>
          Form Input Keuangan
        </Typography>

        <Grid container spacing={3}>
          {/* ── Kolom Kiri: Input Form ──────────────────────────────────── */}
          <Grid item xs={12} md={7}>
            <Paper
              elevation={0}
              sx={{
                ...cardStyle,
                p: { xs: 2, md: 3 },
                borderRadius: "20px",
                border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"}`,
                boxShadow:
                  theme.palette.mode === "dark"
                    ? "0 8px 32px rgba(0,0,0,0.4)"
                    : "0 8px 32px rgba(0,0,0,0.08)",
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(145deg, #1e1e1e, #2a2a2a)"
                    : "#ffffff",
                position: "relative",
                overflow: "hidden",
                zIndex: 1,
              }}
            >
              {/* Decorative Glow */}
              <Box
                sx={{
                  position: "absolute",
                  top: -50,
                  right: -50,
                  width: 200,
                  height: 200,
                  background: `radial-gradient(circle, ${theme.palette.secondary[500]}15 0%, transparent 70%)`,
                  borderRadius: "50%",
                  zIndex: -1,
                }}
              />

              <Tabs
                value={tabValue}
                onChange={(_, v) => setTabValue(v)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  mb: 3,
                  "& .MuiTabs-indicator": {
                    height: "100%",
                    borderRadius: "12px",
                    backgroundColor: theme.palette.secondary[500],
                    opacity: theme.palette.mode === "dark" ? 0.2 : 0.1,
                  },
                  "& .MuiTab-root": {
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "14px",
                    borderRadius: "12px",
                    minHeight: "48px",
                    transition: "all 0.3s ease",
                    color: theme.palette.text.secondary,
                    "&.Mui-selected": {
                      color: theme.palette.secondary[500],
                    },
                    "&:hover": {
                      backgroundColor:
                        theme.palette.mode === "dark"
                          ? "rgba(255,255,255,0.05)"
                          : "rgba(0,0,0,0.03)",
                    },
                  },
                }}
              >
                <Tab
                  icon={<PaymentOutlined />}
                  iconPosition="start"
                  label="Bayar Pengeluaran Terdaftar"
                />
                <Tab
                  icon={<CategoryOutlined />}
                  iconPosition="start"
                  label="Pengeluaran Lainnya"
                />
                <Tab
                  icon={<TrendingUpOutlined />}
                  iconPosition="start"
                  label="Pendapatan Lainnya"
                />
              </Tabs>

              <Divider sx={{ mb: 3, opacity: 0.6 }} />

              {/* ── Tab 1: Bayar Pengeluaran Terdaftar ─────────────────────── */}
              {tabValue === 0 && (
                <Box sx={{ animation: "fadeIn 0.5s ease" }}>
                  <Typography
                    variant="body2"
                    color={theme.palette.text.secondary}
                    mb={2}
                    fontWeight="500"
                  >
                    Pilih transaksi terdaftar, lalu tambahkan ke alokasi.
                  </Typography>

                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => setOpenPilihTransaksi(true)}
                    sx={{
                      height: "60px",
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "15px",
                      borderRadius: "12px",
                      border: `2px dashed ${theme.palette.secondary[400]}`,
                      color: theme.palette.secondary.main,
                      display: "flex",
                      justifyContent: "space-between",
                      px: 3,
                      transition: "all 0.2s ease-in-out",
                      backgroundColor:
                        theme.palette.mode === "dark"
                          ? "rgba(255,255,255,0.02)"
                          : "rgba(0,0,0,0.01)",
                      "&:hover": {
                        backgroundColor: `${theme.palette.secondary.main}15`,
                        borderColor: theme.palette.secondary.main,
                        transform: "translateY(-2px)",
                        boxShadow: `0 4px 12px ${theme.palette.secondary.main}20`,
                      },
                    }}
                  >
                    <span>
                      {selectedTransaksi || selectedTransaksis.length > 0
                        ? selectedTransaksis.length > 0
                          ? `${selectedTransaksis.length} transaksi dipilih`
                          : `${selectedTransaksi.no_bukti_penerimaan} - ${selectedTransaksi.nama_supplier}`
                        : "Pilih Transaksi Pengeluaran"}
                    </span>
                    <PaymentOutlined sx={{ fontSize: "24px" }} />
                  </Button>

                  {(selectedTransaksi || selectedTransaksis.length > 0) && (
                    <Box
                      mt={3}
                      p={2.5}
                      sx={{
                        backgroundColor:
                          theme.palette.mode === "dark"
                            ? "rgba(0,0,0,0.2)"
                            : "rgba(0,0,0,0.02)",
                        borderRadius: "16px",
                        border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"}`,
                      }}
                    >
                      {selectedTransaksis.length > 0 ? (
                        <Box>
                          <Typography
                            variant="body2"
                            fontWeight="600"
                            mb={1.5}
                            color={theme.palette.secondary[300]}
                          >
                            {selectedTransaksis.length} Transaksi Dipilih
                          </Typography>
                          <TableContainer
                            component={Paper}
                            elevation={0}
                            sx={{
                              maxHeight: 250,
                              borderRadius: "12px",
                              border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"}`,
                              backgroundColor: "transparent",
                              "&::-webkit-scrollbar": { width: "6px" },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor: theme.palette.secondary[500],
                                borderRadius: "10px",
                              },
                            }}
                          >
                            <Table size="small" stickyHeader>
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    sx={{
                                      fontWeight: "700",
                                      fontSize: "12px",
                                      backgroundColor:
                                        theme.palette.background.alt,
                                    }}
                                  >
                                    No. Bukti
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontWeight: "700",
                                      fontSize: "12px",
                                      backgroundColor:
                                        theme.palette.background.alt,
                                    }}
                                  >
                                    Supplier
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontWeight: "700",
                                      fontSize: "12px",
                                      backgroundColor:
                                        theme.palette.background.alt,
                                    }}
                                    align="right"
                                  >
                                    Sisa Hutang
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontWeight: "700",
                                      fontSize: "12px",
                                      backgroundColor:
                                        theme.palette.background.alt,
                                    }}
                                    align="right"
                                  >
                                    Nominal Bayar *
                                    <Typography
                                      component="span"
                                      color="error"
                                      sx={{ ml: 0.5, fontSize: "11px" }}
                                    >
                                      Wajib
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedTransaksis.map((item, idx) => (
                                  <TableRow
                                    key={idx}
                                    sx={{
                                      "&:hover": {
                                        backgroundColor:
                                          theme.palette.mode === "dark"
                                            ? "rgba(255,255,255,0.03)"
                                            : "rgba(0,0,0,0.02)",
                                      },
                                    }}
                                  >
                                    <TableCell sx={{ fontSize: "12px" }}>
                                      {item.no_bukti_penerimaan}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: "12px" }}>
                                      {item.nama_supplier}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        color: theme.palette.error.main,
                                      }}
                                      align="right"
                                    >
                                      {formatRupiah(
                                        parseInt(item.sisa_hutang) || 0,
                                      )}
                                    </TableCell>
                                    <TableCell
                                      sx={{ fontSize: "12px" }}
                                      align="right"
                                    >
                                      <TextField
                                        size="small"
                                        variant="outlined"
                                        value={
                                          nominalBayarMulti[
                                            item.no_bukti_penerimaan
                                          ] || ""
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value.replace(
                                            /\D/g,
                                            "",
                                          );
                                          setNominalBayarMulti((prev) => ({
                                            ...prev,
                                            [item.no_bukti_penerimaan]: value
                                              ? parseInt(value)
                                              : 0,
                                          }));
                                        }}
                                        sx={{
                                          width: 140,
                                          "& .MuiOutlinedInput-root": {
                                            borderRadius: "8px",
                                            backgroundColor:
                                              theme.palette.background.default,
                                          },
                                        }}
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment
                                              position="start"
                                              sx={{
                                                fontSize: "12px",
                                                fontWeight: 600,
                                              }}
                                            >
                                              Rp
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                      ) : (
                        <Grid container spacing={2.5}>
                          <Grid item xs={6}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              fontWeight={500}
                            >
                              Tanggal Transaksi
                            </Typography>
                            <Typography variant="body2" fontWeight="600">
                              {moment(
                                selectedTransaksi.tanggal_transaksi,
                              ).format("DD-MM-YYYY")}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              fontWeight={500}
                            >
                              Jatuh Tempo
                            </Typography>
                            <Typography variant="body2" fontWeight="600">
                              {moment(selectedTransaksi.tanggal_transaksi)
                                .add(
                                  parseInt(selectedTransaksi.top) || 0,
                                  "days",
                                )
                                .format("DD-MM-YYYY")}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              fontWeight={500}
                            >
                              Nominal Penerimaan
                            </Typography>
                            <Typography variant="body2" fontWeight="600">
                              {formatRupiah(
                                parseInt(
                                  selectedTransaksi.nominal_penerimaan,
                                ) || 0,
                              )}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              fontWeight={500}
                            >
                              Sisa Hutang
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight="700"
                              color="error.main"
                            >
                              {formatRupiah(
                                parseInt(selectedTransaksi.sisa_hutang) || 0,
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                      )}
                    </Box>
                  )}

                  {(selectedTransaksi || selectedTransaksis.length > 0) && (
                    <Grid container spacing={2} alignItems="center" mt={3}>
                      <Grid item xs={12} sm={8}>
                        <TextField
                          label="Nominal yang Dibayarkan"
                          fullWidth
                          variant="filled"
                          value={nominalBayar}
                          disabled
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Typography fontWeight={600}>Rp</Typography>
                              </InputAdornment>
                            ),
                            disableUnderline: true,
                            sx: {
                              borderRadius: "12px",
                              backgroundColor:
                                theme.palette.mode === "dark"
                                  ? "rgba(255,255,255,0.05)"
                                  : "rgba(0,0,0,0.04)",
                            },
                          }}
                          placeholder="0"
                          helperText={
                            selectedTransaksis.length > 0
                              ? "Isi nominal per item di tabel atas"
                              : "Nominal otomatis terisi dari sisa hutang"
                          }
                          FormHelperTextProps={{ sx: { fontWeight: 500 } }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Button
                          variant="contained"
                          fullWidth
                          onClick={handleTambahAlokasiTerdaftar}
                          startIcon={<AddShoppingCartOutlined />}
                          sx={{
                            height: "56px",
                            textTransform: "none",
                            fontWeight: 700,
                            color: "white",
                            fontSize: "15px",
                            borderRadius: "12px",
                            background: `linear-gradient(45deg, ${theme.palette.secondary[500]}, ${theme.palette.secondary[600]})`,
                            boxShadow: `0 4px 14px ${theme.palette.secondary[500]}40`,
                            transition: "all 0.2s",
                            "&:hover": {
                              transform: "translateY(-2px)",
                              boxShadow: `0 6px 20px ${theme.palette.secondary[500]}60`,
                            },
                          }}
                        >
                          Ke Alokasi
                        </Button>
                      </Grid>
                    </Grid>
                  )}

                  {/* Alerts and validations */}
                  <Box mt={2}>
                    {selectedTransaksi &&
                      selectedTransaksis.length === 0 &&
                      (() => {
                        const rawNominal =
                          parseInt(
                            (nominalBayar || "0").replace(/\D/g, ""),
                            10,
                          ) || 0;
                        const tagihan =
                          parseInt(selectedTransaksi.sisa_hutang) || 0;
                        const selisih = tagihan - rawNominal;

                        if (rawNominal > tagihan) {
                          return (
                            <Alert
                              severity="error"
                              sx={{
                                borderRadius: "12px",
                                alignItems: "center",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                              }}
                            >
                              Nominal pembayaran{" "}
                              <strong>{formatRupiah(rawNominal)}</strong>{" "}
                              melebihi sisa hutang{" "}
                              <strong>{formatRupiah(tagihan)}</strong>. Maksimal
                              yang bisa dibayarkan adalah{" "}
                              <strong>{formatRupiah(tagihan)}</strong>.
                            </Alert>
                          );
                        }
                        if (rawNominal > 0 && rawNominal < tagihan) {
                          return (
                            <Alert
                              severity="warning"
                              sx={{
                                borderRadius: "12px",
                                alignItems: "center",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                              }}
                            >
                              Pengeluaran:{" "}
                              <strong>
                                {selectedTransaksi.no_bukti_penerimaan} -{" "}
                                {selectedTransaksi.nama_supplier}
                              </strong>{" "}
                              — Sisa Hutang:{" "}
                              <strong>{formatRupiah(tagihan)}</strong>
                              <br />
                              Lakukan Kontra Bon sebesar{" "}
                              <strong>{formatRupiah(selisih)}</strong>
                            </Alert>
                          );
                        }
                        return (
                          <Alert
                            severity="info"
                            sx={{
                              borderRadius: "12px",
                              alignItems: "center",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                            }}
                          >
                            Pengeluaran terpilih:{" "}
                            <strong>
                              {selectedTransaksi.no_bukti_penerimaan} -{" "}
                              {selectedTransaksi.nama_supplier}
                            </strong>{" "}
                            — Sisa Hutang:{" "}
                            <strong>{formatRupiah(tagihan)}</strong>
                          </Alert>
                        );
                      })()}

                    {selectedTransaksis.length > 0 &&
                      (() => {
                        const errors = [];
                        const infos = [];

                        selectedTransaksis.forEach((item) => {
                          const nominal =
                            nominalBayarMulti[item.no_bukti_penerimaan] || 0;
                          const tagihan = parseInt(item.sisa_hutang) || 0;

                          if (nominal > tagihan) {
                            errors.push({
                              no: item.no_bukti_penerimaan,
                              nominal,
                              tagihan,
                            });
                          } else if (nominal > 0 && nominal < tagihan) {
                            infos.push({
                              no: item.no_bukti_penerimaan,
                              nominal,
                              tagihan,
                              selisih: tagihan - nominal,
                              supplier: item.nama_supplier,
                            });
                          } else if (nominal === 0) {
                            infos.push({
                              no: item.no_bukti_penerimaan,
                              supplier: item.nama_supplier,
                              tagihan,
                              belum: true,
                            });
                          }
                        });

                        if (errors.length > 0) {
                          return (
                            <Alert
                              severity="error"
                              sx={{
                                borderRadius: "12px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                              }}
                            >
                              {errors.map((err, idx) => (
                                <div key={idx}>
                                  Nominal{" "}
                                  <strong>{formatRupiah(err.nominal)}</strong>{" "}
                                  untuk {err.no} melebihi sisa hutang{" "}
                                  <strong>{formatRupiah(err.tagihan)}</strong>.
                                </div>
                              ))}
                            </Alert>
                          );
                        }

                        if (infos.length > 0) {
                          return (
                            <Alert
                              severity="info"
                              sx={{
                                borderRadius: "12px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                              }}
                            >
                              {infos.map((info, idx) => (
                                <div key={idx} style={{ marginBottom: "4px" }}>
                                  {info.belum
                                    ? `${info.no} - ${info.supplier}: Sisa Hutang ${formatRupiah(info.tagihan)} (belum diisi)`
                                    : `${info.no} - ${info.supplier}: Sisa Hutang ${formatRupiah(info.tagihan)} — Bayar ${formatRupiah(info.nominal)} (Kontra Bon ${formatRupiah(info.selisih)})`}
                                </div>
                              ))}
                            </Alert>
                          );
                        }
                        return null;
                      })()}
                  </Box>
                </Box>
              )}

              {/* ── Tab 2: Pengeluaran Lainnya ─────────────────────────────── */}
              {tabValue === 1 && (
                <Box sx={{ animation: "fadeIn 0.5s ease" }}>
                  <Typography
                    variant="body2"
                    color={theme.palette.text.secondary}
                    mb={3}
                    fontWeight="500"
                  >
                    Isi data pengeluaran lainnya, lalu tambahkan ke alokasi.
                  </Typography>

                  <Autocomplete
                    value={selectedTipe}
                    onChange={(_, newVal) => setSelectedTipe(newVal)}
                    options={list_perkiraan}
                    getOptionLabel={(opt) =>
                      opt.nama_perkiraan
                        ? `${opt.kode_perkiraan} - ${opt.nama_perkiraan}`
                        : opt.kode_perkiraan || ""
                    }
                    filterOptions={(options, { inputValue }) => {
                      const lower = inputValue.toLowerCase();
                      return options.filter(
                        (opt) =>
                          (opt.nama_perkiraan || "")
                            .toLowerCase()
                            .includes(lower) ||
                          (opt.kode_perkiraan || "")
                            .toLowerCase()
                            .includes(lower),
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Tipe Perkiraan"
                        placeholder="Cari nama perkiraan..."
                        fullWidth
                        variant="outlined"
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "12px" },
                        }}
                      />
                    )}
                    noOptionsText="Tipe perkiraan tidak ditemukan"
                    isOptionEqualToValue={(opt, val) =>
                      opt.kode_perkiraan === val.kode_perkiraan
                    }
                    sx={{ mb: 2.5 }}
                  />

                  <TextField
                    label="Nama Pengeluaran"
                    fullWidth
                    variant="outlined"
                    value={namaTransaksi}
                    onChange={(e) => setNamaTransaksi(e.target.value)}
                    placeholder="Contoh: Beli ATK Kantor"
                    sx={{
                      mb: 3,
                      "& .MuiOutlinedInput-root": { borderRadius: "12px" },
                    }}
                  />

                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={8}>
                      <TextField
                        label="Nominal yang Dibayarkan"
                        fullWidth
                        variant="outlined"
                        value={nominalLainnya}
                        onChange={handleNominalChange(setNominalLainnya)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Typography fontWeight={600}>Rp</Typography>
                            </InputAdornment>
                          ),
                        }}
                        placeholder="0"
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "12px" },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={handleTambahAlokasiLainnya}
                        startIcon={<AddShoppingCartOutlined />}
                        sx={{
                          height: "56px",
                          textTransform: "none",
                          fontWeight: 700,
                          fontSize: "15px",
                          borderRadius: "12px",
                          background: `linear-gradient(45deg, ${theme.palette.secondary[500]}, ${theme.palette.secondary[600]})`,
                          boxShadow: `0 4px 14px ${theme.palette.secondary[500]}40`,
                          transition: "all 0.2s",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: `0 6px 20px ${theme.palette.secondary[500]}60`,
                          },
                        }}
                      >
                        Ke Alokasi
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              )}

              {/* ── Tab 3: Pendapatan Lainnya ──────────────────────────────── */}
              {tabValue === 2 && (
                <Box sx={{ animation: "fadeIn 0.5s ease" }}>
                  <Typography
                    variant="body2"
                    color={theme.palette.text.secondary}
                    mb={3}
                    fontWeight="500"
                  >
                    Catat pendapatan di luar setoran reguler (jasa, bunga, dll).
                    Item akan ditambahkan ke <strong>Daftar Alokasi</strong>{" "}
                    sebelum diproses.
                  </Typography>

                  <Autocomplete
                    value={selectedTipePendapatan}
                    onChange={(_, newVal) => setSelectedTipePendapatan(newVal)}
                    options={list_perkiraan || []}
                    getOptionLabel={(opt) =>
                      opt.nama_perkiraan
                        ? `${opt.kode_perkiraan} - ${opt.nama_perkiraan}`
                        : opt.kode_perkiraan || ""
                    }
                    filterOptions={(options, { inputValue }) => {
                      const lower = inputValue.toLowerCase();
                      return options.filter(
                        (opt) =>
                          (opt.nama_perkiraan || "")
                            .toLowerCase()
                            .includes(lower) ||
                          (opt.kode_perkiraan || "")
                            .toLowerCase()
                            .includes(lower),
                      );
                    }}
                    isOptionEqualToValue={(opt, val) =>
                      opt.kode_perkiraan === val.kode_perkiraan
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Kode Perkiraan (Opsional)"
                        placeholder="Cari nama perkiraan..."
                        fullWidth
                        variant="outlined"
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "12px" },
                        }}
                      />
                    )}
                    noOptionsText="Kode perkiraan tidak ditemukan"
                    sx={{ mb: 2.5 }}
                  />

                  <TextField
                    label="Keterangan / Sumber Pendapatan"
                    fullWidth
                    variant="outlined"
                    value={namaPendapatan}
                    onChange={(e) => setNamaPendapatan(e.target.value)}
                    placeholder="Contoh: Pendapatan Jasa Angkut"
                    sx={{
                      mb: 3,
                      "& .MuiOutlinedInput-root": { borderRadius: "12px" },
                    }}
                  />

                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={8}>
                      <TextField
                        label="Nominal Pendapatan"
                        fullWidth
                        variant="outlined"
                        value={nominalPendapatan}
                        onChange={handleNominalChange(setNominalPendapatan)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Typography fontWeight={600}>Rp</Typography>
                            </InputAdornment>
                          ),
                        }}
                        placeholder="0"
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "12px" },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={handleCatatPendapatanLainnya}
                        startIcon={<TrendingUpOutlined />}
                        sx={{
                          height: "56px",
                          textTransform: "none",
                          fontWeight: 700,
                          fontSize: "15px",
                          borderRadius: "12px",
                          background:
                            "linear-gradient(45deg, #4caf50, #43a047)",
                          color: "#fff",
                          boxShadow: "0 4px 14px rgba(76, 175, 80, 0.4)",
                          transition: "all 0.2s",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 6px 20px rgba(76, 175, 80, 0.6)",
                          },
                        }}
                      >
                        Catat Pendapatan
                      </Button>
                    </Grid>
                  </Grid>

                  <Box
                    mt={3}
                    p={2}
                    sx={{
                      borderRadius: "12px",
                      border: "1px dashed rgba(76,175,80,0.5)",
                      backgroundColor:
                        theme.palette.mode === "dark"
                          ? "rgba(76,175,80,0.05)"
                          : "rgba(76,175,80,0.03)",
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                    }}
                  >
                    <TrendingUpOutlined sx={{ color: "#4caf50" }} />
                    <Typography
                      variant="body2"
                      color="#4caf50"
                      fontWeight={500}
                    >
                      Data yang dicatat akan langsung masuk ke{" "}
                      <strong>Riwayat Flow Keuangan</strong> dengan status{" "}
                      <strong>Realisasi Pemasukan</strong>.
                    </Typography>
                  </Box>
                </Box>
              )}
            </Paper>
          </Grid>

          {/* ── Kolom Kanan: Alokasi Pengeluaran ─────────────────────── */}
          <Grid item xs={12} md={5}>
            <Paper
              elevation={0}
              sx={{
                ...cardStyle,
                p: { xs: 2, md: 3 },
                borderRadius: "20px",
                border: `2px solid ${alokasi.length > 0 ? theme.palette.secondary[500] : theme.palette.mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"}`,
                boxShadow:
                  theme.palette.mode === "dark"
                    ? "0 8px 32px rgba(0,0,0,0.4)"
                    : "0 8px 32px rgba(0,0,0,0.08)",
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(145deg, #1e1e1e, #2a2a2a)"
                    : "#ffffff",
                display: "flex",
                flexDirection: "column",
                height: "100%",
                minHeight: 450,
                position: "relative",
                transition: "border-color 0.3s ease",
              }}
            >
              {/* Header Alokasi */}
              <Box display="flex" flexDirection="column" gap={2} mb={2}>
                <Box display="flex" alignItems="center" gap={1.5}>
                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 48,
                      height: 48,
                      borderRadius: "14px",
                      background: `linear-gradient(135deg, ${theme.palette.secondary[500]}20, ${theme.palette.secondary[500]}40)`,
                      color: theme.palette.secondary[500],
                    }}
                  >
                    <Badge
                      badgeContent={alokasi.length}
                      color="error"
                      sx={{
                        "& .MuiBadge-badge": {
                          fontWeight: 700,
                          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                        },
                      }}
                    >
                      <ChecklistOutlined sx={{ fontSize: 26 }} />
                    </Badge>
                  </Box>
                  <Box>
                    <Typography variant="h5" fontWeight="700">
                      Daftar Alokasi
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Ringkasan item pengeluaran
                    </Typography>
                  </Box>
                </Box>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="Tanggal Alokasi"
                    value={tanggalAlokasi}
                    onChange={(val) => setTanggalAlokasi(val)}
                    format="DD/MM/YYYY"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Box>

              <Divider sx={{ mb: 2, opacity: 0.6 }} />

              {/* Isi Alokasi */}
              <Box
                sx={{
                  flex: 1,
                  overflowY: "auto",
                  mb: 2,
                  pr: 1,
                  "&::-webkit-scrollbar": { width: "6px" },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor:
                      theme.palette.mode === "dark"
                        ? "rgba(255,255,255,0.2)"
                        : "rgba(0,0,0,0.2)",
                    borderRadius: "10px",
                  },
                }}
              >
                {alokasi.length === 0 ? (
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ height: "100%", py: 5, opacity: 0.5 }}
                  >
                    <ChecklistOutlined
                      sx={{ fontSize: 64, mb: 2, opacity: 0.3 }}
                    />
                    <Typography
                      variant="body1"
                      fontWeight="600"
                      color={theme.palette.text.secondary}
                    >
                      Belum Ada Alokasi
                    </Typography>
                    <Typography
                      variant="caption"
                      color={theme.palette.text.secondary}
                      textAlign="center"
                      mt={1}
                    >
                      Silakan tambahkan item
                      <br />
                      dari form di samping.
                    </Typography>
                  </Box>
                ) : (
                  alokasi.map((item, index) => (
                    <Box
                      key={item.id}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 2,
                        mb: 1.5,
                        borderRadius: "14px",
                        backgroundColor:
                          theme.palette.mode === "dark"
                            ? "rgba(255,255,255,0.03)"
                            : "rgba(0,0,0,0.02)",
                        border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)"}`,
                        transition: "all 0.2s ease",
                        "&:hover": {
                          backgroundColor:
                            theme.palette.mode === "dark"
                              ? "rgba(255,255,255,0.06)"
                              : "rgba(0,0,0,0.04)",
                          transform: "translateY(-2px)",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                          borderColor: theme.palette.secondary[400],
                        },
                      }}
                    >
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={1}
                          mb={0.8}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              px: 1.2,
                              py: 0.3,
                              borderRadius: "6px",
                              fontWeight: 700,
                              fontSize: "10px",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px",
                              color: "#fff",
                              background:
                                item.sumber === "Terdaftar"
                                  ? "linear-gradient(45deg, #2196f3, #1976d2)"
                                  : "linear-gradient(45deg, #ff9800, #f57c00)",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                            }}
                          >
                            {item.sumber}
                          </Typography>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            fontWeight="600"
                          >
                            #{index + 1}
                          </Typography>
                        </Box>
                        <Typography
                          variant="body2"
                          fontWeight="600"
                          sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            mb: 0.5,
                          }}
                        >
                          {item.keterangan}
                        </Typography>
                        <Typography
                          variant="body1"
                          fontWeight="700"
                          color={theme.palette.secondary[500]}
                        >
                          {formatRupiah(item.nominal)}
                        </Typography>
                      </Box>
                      <Box
                        display="flex"
                        flexDirection="column"
                        gap={0.5}
                        ml={1.5}
                      >
                        <IconButton
                          size="small"
                          onClick={() => handleEditAlokasi(item)}
                          sx={{
                            color: "#2196f3",
                            backgroundColor: "rgba(33,150,243,0.1)",
                            borderRadius: "8px",
                            "&:hover": {
                              backgroundColor: "rgba(33,150,243,0.2)",
                            },
                          }}
                        >
                          <EditOutlined fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleHapusDariAlokasi(item.id)}
                          sx={{
                            color: "#f44336",
                            backgroundColor: "rgba(244,67,54,0.1)",
                            borderRadius: "8px",
                            "&:hover": {
                              backgroundColor: "rgba(244,67,54,0.2)",
                            },
                          }}
                        >
                          <DeleteOutline fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  ))
                )}
              </Box>

              {/* Footer Alokasi */}
              {alokasi.length > 0 && (
                <Box sx={{ mt: "auto", pt: 2 }}>
                  <Divider sx={{ mb: 2, opacity: 0.6 }} />
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2.5}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="600"
                      color="text.secondary"
                    >
                      Total ({alokasi.length} item)
                    </Typography>
                    <Typography
                      variant="h4"
                      fontWeight="800"
                      sx={{
                        background: `linear-gradient(45deg, ${theme.palette.secondary[300]}, ${theme.palette.secondary[600]})`,
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                      }}
                    >
                      {formatRupiah(totalAlokasi)}
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    fullWidth
                    size="large"
                    onClick={handleProsesAlokasi}
                    startIcon={<SendOutlined />}
                    sx={{
                      textTransform: "none",
                      fontWeight: 800,
                      color: "white",
                      fontSize: "16px",
                      py: 1.8,
                      borderRadius: "14px",
                      background: `linear-gradient(45deg, ${theme.palette.secondary[500]}, ${theme.palette.secondary[700]})`,
                      boxShadow: `0 6px 20px ${theme.palette.secondary[500]}50`,
                      transition: "all 0.2s",
                      "&:hover": {
                        transform: "translateY(-3px)",
                        boxShadow: `0 8px 25px ${theme.palette.secondary[500]}70`,
                      },
                    }}
                  >
                    Proses Semua Pengeluaran
                  </Button>
                </Box>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Box>

      {/* ── Snackbar Feedback ───────────────────────────────────────────────── */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%", borderRadius: "8px" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <FloatingAlert
        open={message.length > 0}
        onClose={handleCloseSnackbar}
        message={message}
        severity={status === "failed" ? "error" : status}
      />
      <KonfirmasiModal
        titleType={"Hapus"}
        subtitleType={"Menghapus"}
        dataWillProses={selectedTransaksi?.nama}
        open={openKonfirmasi}
        onClose={() => {
          setOpenKonfirmasi(false);
          setSelectedTransaksi(null);
          setTanggalPengganti(null);
        }}
        onSubmit={() => handleDelete()}
      />
      <UbahTanggalModal
        open={openUbahTanggal}
        onClose={() => {
          setOpenUbahTanggal(false);
          setSelectedTransaksi(null);
          setTanggalPengganti(null);
        }}
        onSubmit={handleUbahTanggal}
        selectedTransaksi={selectedTransaksi}
        tanggalPengganti={tanggalPengganti}
        setTanggalPengganti={setTanggalPengganti}
      />

      <DetailSetoranCabangModal
        open={openDetailSetoranCabang}
        onClose={() => setOpenDetailSetoranCabang(false)}
        data={list_setoran_percabang}
        loading={isLoading}
      />

      {/* ── Modal Pilih Transaksi ─────────────────────── */}
      <Dialog
        open={openPilihTransaksi}
        onClose={() => setOpenPilihTransaksi(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box display="flex" alignItems="center" gap={1}>
            <PaymentOutlined color="primary" />
            <Typography variant="h6" fontWeight="bold">
              Pilih Transaksi Pengeluaran
            </Typography>
          </Box>
          <IconButton onClick={() => setOpenPilihTransaksi(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box mb={3}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <DatePicker
                      label="Mulai"
                      value={startJatuhTempo}
                      onChange={(newValue) => setStartJatuhTempo(newValue)}
                      slotProps={{
                        textField: { size: "small", sx: { width: 160 } },
                      }}
                    />
                    <Typography>-</Typography>
                    <DatePicker
                      label="Akhir"
                      value={endJatuhTempo}
                      onChange={(newValue) => setEndJatuhTempo(newValue)}
                      slotProps={{
                        textField: { size: "small", sx: { width: 160 } },
                      }}
                    />
                  </Box>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Cari Supplier atau No. Bukti"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Button
                  variant="outlined"
                  onClick={handleResetFilterTransaksi}
                  fullWidth
                  sx={{ height: "40px" }}
                >
                  Reset Filter
                </Button>
              </Grid>
            </Grid>
          </Box>

          <TableContainer
            component={Paper}
            variant="outlined"
            sx={{ maxHeight: 400 }}
          >
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow
                  sx={{ backgroundColor: theme.palette.background.alt }}
                >
                  <TableCell padding="checkbox" sx={{ fontWeight: "bold" }}>
                    <Checkbox
                      indeterminate={
                        selectedTransaksis.length > 0 &&
                        selectedTransaksis.length < filteredListTransaksi.length
                      }
                      checked={
                        filteredListTransaksi.length > 0 &&
                        selectedTransaksis.length ===
                          filteredListTransaksi.length
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedTransaksis([...filteredListTransaksi]);
                        } else {
                          setSelectedTransaksis([]);
                        }
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>No. Bukti</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Tanggal Transaksi
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Supplier</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">
                    Nominal
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">
                    Sisa Hutang
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="center">
                    TOP (Hari)
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="center">
                    Jatuh Tempo
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredListTransaksi.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                      <Typography color="text.secondary">
                        Tidak ada transaksi ditemukan
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredListTransaksi.map((item, index) => {
                    const tglTransaksi = moment(item.tanggal_transaksi);
                    const top = parseInt(item.top) || 0;
                    const tglJatuhTempo = tglTransaksi.clone().add(top, "days");
                    const today = moment();
                    const isLewat = tglJatuhTempo.isBefore(today, "day");
                    const isLunas =
                      parseInt(item.sisa_hutang) === 0 ||
                      parseInt(item.sisa_hutang) < 0;
                    const isSelected = selectedTransaksis.some(
                      (t) => t.no_bukti_penerimaan === item.no_bukti_penerimaan,
                    );

                    return (
                      <TableRow
                        key={index}
                        hover
                        selected={isSelected}
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleToggleTransaksi(item)}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={isSelected}
                            onClick={(e) => e.stopPropagation()}
                            onChange={() => handleToggleTransaksi(item)}
                          />
                        </TableCell>
                        <TableCell>{item.no_bukti_penerimaan || "-"}</TableCell>
                        <TableCell>
                          {tglTransaksi.format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell>{item.nama_supplier || "-"}</TableCell>
                        <TableCell align="right">
                          {formatRupiah(parseInt(item.nominal_penerimaan) || 0)}
                        </TableCell>
                        <TableCell align="right">
                          <Typography
                            color={isLunas ? "success" : "error"}
                            fontWeight={isLunas ? "normal" : "bold"}
                          >
                            {formatRupiah(parseInt(item.sisa_hutang) || 0)}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">{top}</TableCell>
                        <TableCell align="center">
                          <Chip
                            label={tglJatuhTempo.format("DD-MM-YYYY")}
                            size="small"
                            color={
                              isLewat && !isLunas
                                ? "error"
                                : isLewat && isLunas
                                  ? "success"
                                  : "default"
                            }
                            variant={
                              isLewat && !isLunas ? "filled" : "outlined"
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ mt: 1 }}
          >
            <Typography variant="body2" color="text.secondary">
              Total: {filteredListTransaksi.length} transaksi | Selected:{" "}
              {selectedTransaksis.length}
            </Typography>
            <Button
              variant="contained"
              onClick={handlePilihMultiple}
              disabled={selectedTransaksis.length === 0}
              sx={{ textTransform: "none" }}
            >
              Pilih ({selectedTransaksis.length})
            </Button>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setOpenPilihTransaksi(false)}
            sx={{ textTransform: "none" }}
          >
            Tutup
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export default AlokasiDC;
